import React, { Component, createRef } from "react";

import {
  COMPANY_NAME,
  dateString,
  APP_URL,
  AGENT_SERVER_URL,
  APP_LIVE_URL,
  API_URL,
  THEME_TEXT_COLOR,
  THEME_COLOR,
  columnsServices,
} from "../../../config/config";
import axios from "axios";
import { connect } from "react-redux";

import { addSettings } from "../../../actions";

import {
  getSingleSubpoenaReport,
  updateRequesterInfo,
  updateRequestInfo,
  addRequestComments,
  approveSubpoenaReport,
  getApprovalLogs,
  deleteResultDocument,
} from "./../../../config/subpoena_api_calls";
import { getCustomSettings } from "./../../../config/reseller_api_calls";

import $ from "jquery";

import DataTable from "../../../components/Tables/DataTableReports";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import { Link } from "react-router-dom";
import { FormLoader } from "../../../components/ContentLoaders/newLoaders/Form";
import { TableLoader } from "../../../components/ContentLoaders/newLoaders/TableLoader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import Tooltip from "@material-ui/core/Tooltip";
import RichTextEditorComponent from "../../../components/Reseller/RichTextEditorComponent";
import dateFormat, { masks } from "dateformat";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";

import HomeIcon from "@material-ui/icons/Home";
import TextField from "../../../components/InputFields/TextField";
import MutextField from "@material-ui/core/TextField";
import * as XLSX from "xlsx";
import moment from "moment";
import DateFnsUtils from "@date-io/date-fns"; // choose your lib
import {
  DatePicker,
  DateTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateRangePicker from "react-daterange-picker";
import "react-daterange-picker/dist/css/react-calendar.css";
import { extendMoment } from "moment-range";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import {
  encryptValue,
  parseAndDecryptFromState,
  buildEncryptedQueryString,
} from "../../../components/Encryption/cryptoUtils";
import { CopyToClipboard } from "react-copy-to-clipboard";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";

import GooglePlacesAutocomplete from "react-google-places-autocomplete";

import { PhoneInput } from "react-international-phone";
import { PhoneNumberUtil } from "google-libphonenumber";
import { ValidateEmail } from "../../../config/utility";

const extendedMoment = extendMoment(moment);

const animatedComponents = makeAnimated();

const auth = new HelperClass();

class EditSubpoenaReport extends Component {
  constructor() {
    var date = (date = new Date()),
      y = date.getFullYear(),
      m = date.getMonth();

    var datestring = new Date().toISOString().slice(0, 10);

    super();
    this.decimalPoint = Number(auth.getDecimalPoint());
    this.billing_decimalPoint = Number(auth.getBillingDecimalPoint());
    const today = extendedMoment();
    const monthAgo = moment().subtract(7, "day");
    this.state = {
      tableData: [],
      tableLoader: true,
      //start_date: monthAgo.format("YYYY-MM-DD"),
      //end_date: today.format("YYYY-MM-DD"),
      disabled: false,
      errorMessage: "",
      errorMessageTitle: "",
      successMessage: "",
      docErrorMessage: "",
      docErrorMessageResult: "",
      title: "",
      title_edit: "",
      subpoena_ren_no: "",
      subpoena_ren_no_edit: "",
      start_date: monthAgo.format("MM-DD-yyyy"),
      end_date: today.format("MM-DD-yyyy"),
      value: moment.range(monthAgo, today),
      description: "",
      report_params: "",
      report_url_id: "",
      add_picture: "",
      report_id: "",
      comments: "",
      publish_report: "No",
      status: "",
      added_file: [],
      added_file_did: "",
      isEditorReady: false,
      add_pictures: [],
      add_picture_names: [],
      result_document: "",
      result_documents: [],
      result_documents_names: [],
      tags: [],
      inputValue: "",
      subscriber_settings: false,
      billing_settings: false,
      other_did_settings: false,
      contract_settings: false,
      communication_settings: false,
      payment_settings: false,
      didErrorMessage: "",
      enableDids: "dids",
      maxChars: 1000,

      is_encrypted: "No",
      copied: false,
      extra_params: "",
      extra_params_array: [{}],
      extra_params_title: "",
      jumpErrorTitle: "",
      jumpError: "",

      subpoenaOptions: [
        {
          name: "Full Subscriber Name",
          value: "Full Subscriber Name",
          checked: false,
        },
        {
          name: "Billing and service address",
          value: "Billing and service address",
          checked: false,
        },
        {
          name: "Email address(es) associated with account",
          value: "Email address(es) associated with account",
          checked: false,
        },
        {
          name: "Account creation date and termination date (if applicable)",
          value: "Account creation date and termination date (if applicable)",
          checked: false,
        },
        { name: "Account number", value: "Account number", checked: false },
        {
          name: "IP address logs (registration and logins)",
          value: "IP address logs (registration and logins)",
          checked: false,
        },
        {
          name: "Call/SMS metadata logs",
          value: "Call/SMS metadata logs",
          checked: false,
        },
        {
          name: "Device identifiers, if available (IMEI, MAC, etc.)",
          value: "Device identifiers, if available (IMEI, MAC, etc.)",
          checked: false,
        },
        {
          name: "Payment information or method on file (if applicable)",
          value: "Payment information or method on file (if applicable)",
          checked: false,
        },
      ],
      newName: "",
      newValue: "",
      optionsSelected: [],
      optionsContainer: false,

      emailCcs: [],
      inputValueCc: "",
      ccErrorMessage: "",

      emailCcsApproval: [],
      inputValueCcApproval: "",
      ccErrorMessageApproval: "",

      address_autocomplete: true,
      useGooglePlaces: true,
      address_validation: true,
      notifyCheckBox: false,
      requester_address: "",
      requester_phone: "",
      requester_name: "",
      requester_type: "Federal Agency",
      office_devision: "",
      requester_contact_name: "",
      requester_contact_title: "",
      requester_email: "",
      legal_authority_cited: "Federal",
      request_type: "Subpoena",
      request_type_other: "",
      activeTab: "requester_info",
      created_date: "",
      last_updated: "",
      published_date: "",
      notifyRequester: false,
      successMessageRequester: "",
      errorMessageRequester: "",
      errorMessageRequesterTitle: "",
      requester_info_button: false,
      notifyRequest: false,
      errorMessageRequest: "",
      errorMessageRequestTitle: "",
      successMessageRequest: "",
      request_info_button: false,
      notifyRecordsSought: false,
      errorMessageSought: "",
      errorMessageSoughtTitle: "",
      successMessageSought: "",
      records_sought_button: false,
      notifyUpdateDocuments: false,
      errorMessageDocuments: "",
      errorMessageDocumentsTitle: "",
      successMessageDocuments: "",
      update_documents_buttons: false,

      errorMessageComments: "",
      errorMessageCommentsTitle: "",
      successMessageComments: "",
      add_comments_button: false,
      allComments: [],

      approvalAlertMessage: "",
      approvalErrorMessage: "",
      approvalErrorMessageTitle: "",
      approval_main_section: false,
      approvalSuccessMessage: "",
      notifyApproval: false,
      approval_notes: "",
      approve_client_button: false,
      approval_subpoena_id: "",
      approval_logs_main_section: false,
      approvalLogs: [],
      approvalLogErrorMessageTitle: "",
      approvalLogErrorMessage: "",
      approval_requester_email: "",

      activeAccordion: null,
      visibleCount: 5,

      show_report_link: "No",
      dueDate: new Date(new Date().setDate(new Date().getDate() + 1)),
      progressPercentage: 0,
      soughtArray: [],
      choose_option_title: "",

      deleteErrorMessage: "",
      deleteSuccessMessage: "",
      notifyDeletion: false,
      delete_file_index: "",
      delete_file_id: "",
      delete_requested_option: "",
    };
    this.phoneInputRef = createRef();
  }

  serviceSigning = async (value, tableMeta) => {
    // console.log("tableMeta.rowData: ", tableMeta.rowData[6]);
  };

  async componentDidMount() {
    this.setState({
      tableLoader: false,
      tableLoaderListing: false,
    });
    if (
      this.props.props.match.params.report_id &&
      this.props.props.match.params.report_id !== ""
    ) {
      let request_id = this.props.props.match.params.report_id;
      this.setState({ report_id: request_id });
      await this.getCustomSettings();
      await this.getSingleRequest(request_id);
    }
  }

  getSingleRequest = async (request_id) => {
    const { subpoenaOptions } = this.state;
    const saveResponce = await getSingleSubpoenaReport(
      auth.getAccount(),
      auth.getToken(),
      request_id,
    );
    console.log("getSingleRequest: ", saveResponce.data);
    if (
      saveResponce.data.status === 403 ||
      saveResponce.data.errors === "authentication missing" ||
      saveResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      saveResponce.data.status === 404 &&
      saveResponce.data.message === "Not Verified"
    ) {
      this.setState({
        mcqLoader: false,
        isEditorReady: true,
      });
    } else if (saveResponce.data.status === 200) {
      let added_file = [];

      if (
        saveResponce.data.data[0]["files"] &&
        saveResponce.data.data[0]["files"].length > 0
      ) {
        added_file = saveResponce.data.data[0]["files"];
        let updatedData = added_file.map((item) => ({
          ...item,
          added_file: item.added_file.split(", "), // Split string into an array by comma and space
        }));
        //console.log("[updatedData] ", updatedData);
        this.setState({
          added_file: updatedData,
        });
      }
      console.log(added_file);

      const start_date = saveResponce.data.data[0]["start_date"]
        ? moment(saveResponce.data.data[0]["start_date"])
        : moment();
      const end_date = saveResponce.data.data[0]["end_date"]
        ? moment(saveResponce.data.data[0]["end_date"])
        : moment().add(7, "days");

      let is_encrypted = "No";
      if (
        saveResponce.data.data[0]["extra_params"] &&
        saveResponce.data.data[0]["extra_params"] !== ""
      ) {
        is_encrypted = "Yes";
      }

      let extra_params_arr = [{}];
      if (
        saveResponce.data.data[0]["extra_params"] &&
        saveResponce.data.data[0]["extra_params"].length > 0
      ) {
        for (
          let i = 0;
          i < saveResponce.data.data[0]["extra_params"].length;
          i++
        ) {
          let inner = {
            title: saveResponce.data.data[0]["extra_params"][i]["param_title"],
            parameter:
              saveResponce.data.data[0]["extra_params"][i]["extra_params"],
          };
          extra_params_arr.push(inner);
        }
      }

      let secondArray = saveResponce.data.data[0]["allOptions"];

      let totalOptions = secondArray.length;
      let completedOptions = secondArray.filter(
        (item) => item.result_status === 1,
      ).length;
      // Calculate percentage
      const progressPercentage =
        totalOptions > 0 ? (completedOptions / totalOptions) * 100 : 0;

      let map = new Map(subpoenaOptions.map((item) => [item.name, item]));

      // Loop through second array
      if (secondArray && secondArray.length > 0) {
        secondArray.forEach((item) => {
          if (map.has(item.requested_option)) {
            // Update checked = true if exists
            map.get(item.requested_option).checked = true;
          } else {
            // Add new entry if not exists
            subpoenaOptions.push({ ...item, checked: true });
          }
        });
      }

      let soughtArray = saveResponce.data.data[0]["allOptions"];
      const matchedTitles = added_file.map((item) => item.choose_option_title);
      const newSoughtArray = soughtArray.filter(
        (item) => !matchedTitles.includes(item.requested_option),
      );

      let requester_address = "";
      let requester_phone = "";
      let requester_name = "";
      let requester_type = "Federal Agency";
      let office_devision = "";
      let requester_contact_name = "";
      let requester_contact_title = "";
      let requester_email = "";
      let legal_authority_cited = "Federal";
      let request_type = "Subpoena";
      let request_type_other = "";
      if (
        saveResponce.data.data[0]["requester_info"] &&
        saveResponce.data.data[0]["requester_info"].length > 0
      ) {
        requester_address =
          saveResponce.data.data[0]["requester_info"][0]["requester_address"];
        requester_phone =
          saveResponce.data.data[0]["requester_info"][0]["requester_phone"];
        requester_name =
          saveResponce.data.data[0]["requester_info"][0]["requester_name"];
        requester_type =
          saveResponce.data.data[0]["requester_info"][0]["requester_type"];
        office_devision =
          saveResponce.data.data[0]["requester_info"][0]["office_devision"];
        requester_contact_name =
          saveResponce.data.data[0]["requester_info"][0][
            "requester_contact_name"
          ];
        requester_contact_title =
          saveResponce.data.data[0]["requester_info"][0][
            "requester_contact_title"
          ];
        requester_email =
          saveResponce.data.data[0]["requester_info"][0]["requester_email"];
        legal_authority_cited =
          saveResponce.data.data[0]["requester_info"][0][
            "legal_authority_cited"
          ];
        request_type =
          saveResponce.data.data[0]["requester_info"][0]["request_type"];
        if (
          saveResponce.data.data[0]["requester_info"][0]["request_type"] ===
          "Other"
        ) {
          request_type_other =
            saveResponce.data.data[0]["requester_info"][0][
              "request_type_other"
            ];
        }
      }

      let show_report_link = "No";
      if (
        saveResponce.data.data[0]["url"] &&
        saveResponce.data.data[0]["url"] !== ""
      ) {
        show_report_link = "Yes";
      }
      let dueDate = new Date();
      if (
        saveResponce.data.data[0]["dueDate"] &&
        saveResponce.data.data[0]["dueDate"] !== ""
      ) {
        dueDate = saveResponce.data.data[0]["dueDate"];
      }
      this.setState({
        title: saveResponce.data.data[0]["title"],
        title_edit: saveResponce.data.data[0]["title"],
        start_date: start_date.format("MMMM DD, YYYY"),
        end_date: end_date.format("MMMM DD, YYYY"),
        dueDate: dueDate,
        value: moment.range(start_date, end_date),
        created_date: saveResponce.data.data[0]["created_at"],
        last_updated: saveResponce.data.data[0]["last_updated"],
        published_date: saveResponce.data.data[0]["published_at"],
        description: saveResponce.data.data[0]["description"],
        report_params: saveResponce.data.data[0]["params"],
        report_url_id: saveResponce.data.data[0]["url"],
        status: saveResponce.data.data[0]["status"],
        add_picture: "",
        report_id: saveResponce.data.data[0]["id"],
        publish_report:
          saveResponce.data.data[0]["report_status"] === 1 ? "Yes" : "No",

        tags: saveResponce.data.data[0]["dids"],
        subpoena_ren_no: saveResponce.data.data[0]["subpoena_ren_no"],
        subpoena_ren_no_edit: saveResponce.data.data[0]["subpoena_ren_no"],
        subscriber_settings:
          saveResponce.data.data[0]["subscriber_settings"] === 1 ? true : false,
        billing_settings:
          saveResponce.data.data[0]["billing_settings"] === 1 ? true : false,
        other_did_settings:
          saveResponce.data.data[0]["other_did_settings"] === 1 ? true : false,
        contract_settings:
          saveResponce.data.data[0]["contract_settings"] === 1 ? true : false,
        communication_settings:
          saveResponce.data.data[0]["communication_settings"] === 1
            ? true
            : false,
        payment_settings:
          saveResponce.data.data[0]["payment_settings"] === 1 ? true : false,
        enableDids: saveResponce.data.data[0]["did_type"],
        extra_params_array: extra_params_arr,
        optionsSelected: saveResponce.data.data[0]["requested_options"],
        emailCcs: saveResponce.data.data[0]["email_cc"],
        added_file_did: saveResponce.data.data[0]["request_file"],
        //Requester Info
        requester_address: requester_address ? requester_address : "",
        requester_phone: requester_phone ? requester_phone : "",
        requester_name: requester_name ? requester_name : "",
        requester_type: requester_type ? requester_type : "",
        request_type_other: request_type_other,
        office_devision: office_devision ? office_devision : "",
        requester_contact_name: requester_contact_name
          ? requester_contact_name
          : "",
        requester_contact_title: requester_contact_title
          ? requester_contact_title
          : "",
        requester_email: requester_email ? requester_email : "",
        legal_authority_cited: legal_authority_cited
          ? legal_authority_cited
          : "",
        request_type: request_type ? request_type : "",
        allComments: saveResponce.data.data[0]["allComments"],
        show_report_link: show_report_link,
        progressPercentage: progressPercentage,
        soughtArray: newSoughtArray,
        //added_file: added_file,
        isEditorReady: true,
      });
      this.makeURLString();
    } else {
      this.setState({
        mcqLoader: false,
        isEditorReady: true,
      });
    }
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  format_date = (value) => {
    let date = value;
    if (date && date !== "") {
      return dateFormat(date, "mm-dd-yyyy");
    } else {
      return "---";
    }
  };

  format_date_time = (value) => {
    let date = value;
    if (date && date !== "") {
      return dateFormat(date, "mm-dd-yyyy HH:MM:ss");
    } else {
      return "---";
    }
  };

  handleChangesEnc = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    const hasEnc = value.includes("enc=");
    let is_encrypted = "No";
    if (hasEnc) {
      is_encrypted = "Yes";
    }
    this.setState({
      [name]: value,
      is_encrypted: is_encrypted,
    });
  };

  handleRemoveSpecificRow = (idx) => () => {
    const extra_params_array = [...this.state.extra_params_array];
    extra_params_array.splice(idx, 1);
    this.setState({ extra_params_array });
  };

  addParams = () => {
    const { extra_params, extra_params_title } = this.state;
    this.setState({
      jumpErrorTitle: "",
      jumpError: "",
    });
    if (extra_params !== "" && extra_params_title !== "") {
      const hasEnc = extra_params.includes("enc=");
      if (hasEnc) {
        let newParam = {
          title: extra_params_title,
          parameter: extra_params,
        };
        this.setState((prevState) => ({
          extra_params_array: [...prevState.extra_params_array, newParam],
          extra_params_title: "",
        }));
        this.decrypt_parameters();
      } else {
        this.setState({
          jumpError: "Please encrypt the parameters to proceed.",
        });

        //return false;
        setTimeout(() => {
          this.setState({ jumpErrorTitle: "", jumpError: "" });
        }, 4000);
      }
    } else {
      this.setState({
        jumpError: "Please enter the parameter title and parameters.",
      });

      setTimeout(() => {
        this.setState({ jumpErrorTitle: "", jumpError: "" });
      }, 4000);
    }
    //console.log("extra_params_array: ", this.state.extra_params_array);
  };

  encrypt_parameters = () => {
    const { extra_params } = this.state;

    if (extra_params && extra_params !== "") {
      // Remove leading '?' if present
      const cleanParams = extra_params.startsWith("?")
        ? extra_params.substring(1)
        : extra_params;

      // Encrypt the full query string
      const encrypted = encryptValue(cleanParams);

      // Set new URL with only ?enc=...
      const finalUrl = `?enc=${encrypted}`;

      this.setState({ extra_params: finalUrl, is_encrypted: "Yes" });
    } else {
      this.setState({ jumpError: "Please enter the parameters to encrypt." });
      setTimeout(() => {
        this.setState({ jumpErrorTitle: "", jumpError: "" });
      }, 4000);
    }
  };

  decrypt_parameters = () => {
    const { extra_params } = this.state;
    const parsedParams = parseAndDecryptFromState(extra_params);
    if (parsedParams) {
      this.setState({ extra_params: parsedParams, is_encrypted: "No" });
      // console.log("Decrypted & Parsed Params:", parsedParams);
      // Example: { dash_id: "234", date_filter: "2025-06-16", company_name: "ABC Company" }
    } else {
      console.warn("Invalid or incomplete query string.");
    }
  };

  handleChangeTag = (event) => {
    const { value } = event.target;
    // Allow only numbers
    if (/^\d*$/.test(value)) {
      this.setState({ inputValue: value, didErrorMessage: "" });
    }
  };

  handleChangeRef = (event) => {
    const { value } = event.target;

    // Validation: Only allow a-z, A-Z, 0-9, -, _
    const regex = /^[a-zA-Z0-9\-_]*$/;

    if (!regex.test(value)) {
      this.setState({
        errorMessage: "Only letters, numbers, '-' and '_' are allowed.",
      });
      return;
    }

    // Validation: Maximum 25 characters
    if (value.length > 25) {
      this.setState({ errorMessage: "Maximum 25 characters allowed!" });
      return;
    }

    // Update state if valid
    this.setState({ subpoena_ren_no_edit: value, errorMessage: "" });
  };

  handlePaste = (event) => {
    event.preventDefault();
    const pastedText = event.clipboardData.getData("text");
    this.setState({ inputValue: pastedText }, this.addNumbers);
  };

  handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === ",") {
      event.preventDefault();

      this.addNumbers();
    }
  };

  addNumbers = () => {
    const { inputValue, tags } = this.state;
    if (!inputValue.trim()) return;

    // Split input by commas and remove extra spaces
    let newNumbers = inputValue
      .split(",") // Split by comma
      .map((num) => num.trim()) // Remove extra spaces
      .filter((num) => num); // Remove empty values

    // Keep only numeric values
    newNumbers = newNumbers.filter((num) => /^\d+$/.test(num));

    // Ensure each number is exactly 10 digits
    const invalidNumbers = newNumbers.filter((num) => num.length !== 10);
    if (invalidNumbers.length > 0) {
      this.setState({
        didErrorMessage: "All numbers must be exactly 10 digits!",
      });
      return;
    }

    // Remove duplicates (both within new input and existing tags)
    newNumbers = [...new Set(newNumbers)].filter((num) => !tags.includes(num));

    // Check maximum limit (100 numbers)
    if (tags.length + newNumbers.length > 100) {
      this.setState({ didErrorMessage: "Maximum 100 numbers allowed!" });
      return;
    }

    this.setState((prevState) => ({
      tags: [...prevState.tags, ...newNumbers],
      inputValue: "",
      didErrorMessage: "",
    }));
  };

  handleRemoveTag = (index) => {
    this.setState((prevState) => ({
      tags: prevState.tags.filter((_, i) => i !== index),
    }));
  };

  onSelect = (value) => {
    this.setState({
      value,
      start_date: value.start.format("MM-DD-yyyy"),
      end_date: value.end.format("MM-DD-yyyy"),
      isOpen: false,
    });
  };

  onToggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  checkNumber = async (evt) => {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var keyCode = key;
    key = String.fromCharCode(key);
    if (key.length == 0) return;
    var regex = /^[0-9.\b]+$/;
    if (keyCode == 188 || keyCode == 190) {
      return;
    } else {
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  };

  handleChanges = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    /*this.setState({
      [name]: value,
    });*/
    this.setState({ [name]: value }, () => {
      if (name === "report_url_id" || name === "report_params") {
        this.makeURLString(); // state is now up-to-date
      }
    });
  };

  handleChange = (input) => (e) => {
    this.setState({ [input]: e.target.value });
  };

  handleEditorChange = (updatedContent) => {
    //console.log('updatedContent: ',updatedContent);
    this.setState({ description: updatedContent });
  };

  handleFileChange = (e) => {
    const { added_file_did } = this.state;
    if (added_file_did === "") {
      const selectedFiles = Array.from(e.target.files); // Convert FileList to an array

      if (!selectedFiles.length) return; // No files selected

      // File type validation
      const allowedFileTypes = [
        ".txt",
        ".pdf",
        ".csv",
        ".xlsx",
        ".xls",
        ".zip",
      ];
      const invalidFiles = selectedFiles.filter(
        (file) =>
          !allowedFileTypes.includes(
            `.${file.name.split(".").pop().toLowerCase()}`,
          ),
      );

      if (invalidFiles.length > 0) {
        this.setState({
          docErrorMessage:
            "Invalid file type detected. Please select valid files.",
        });
        return;
      }

      // File size validation (50MB max per file)
      const maxSizeBytes = 50 * 1024 * 1024;
      const oversizedFiles = selectedFiles.filter(
        (file) => file.size > maxSizeBytes,
      );

      if (oversizedFiles.length > 0) {
        this.setState({
          docErrorMessage:
            "Some files exceed the 50MB limit. Choose smaller files.",
        });
        return;
      }

      // Debugging output to ensure files are being processed correctly
      // console.log("Selected Files: ", selectedFiles);
      // console.log("Current add_pictures in state: ", this.state.add_pictures);

      // Append new files to existing array
      this.setState((prevState) => {
        const updatedPictures = [...prevState.add_pictures, ...selectedFiles];
        // console.log("Updated Pictures: ", updatedPictures);
        // **Limit total files to 5**
        if (updatedPictures.length > 1) {
          return {
            docErrorMessage: "You can upload a maximum of 1 file.",
          };
        }
        return {
          add_pictures: updatedPictures,
          docErrorMessage: "", // Clear error message
          add_picture_names: updatedPictures.map((file) => file.name),
        };
      });
    } else {
      this.setState({
        docErrorMessage:
          "To proceed, please remove the file that has already been added.",
      });
      return;
    }
  };

  handleFileChangeResult = (e) => {
    const selectedFiles = Array.from(e.target.files); // Convert FileList to an array

    if (!selectedFiles.length) return; // No files selected

    // File type validation
    const allowedFileTypes = [
      ".txt",
      ".pdf",
      ".csv",
      ".xlsx",
      ".xls",
      ".zip",
      ".jpg",
      ".png",
      ".docx",
      ".doc",
    ];

    const invalidFiles = selectedFiles.filter(
      (file) =>
        !allowedFileTypes.includes(
          `.${file.name.split(".").pop().toLowerCase()}`,
        ),
    );

    if (invalidFiles.length > 0) {
      this.setState({
        docErrorMessageResult:
          "Invalid file type detected. Please select valid files.",
      });
      return;
    }

    // File size validation (50MB max per file)
    const maxSizeBytes = 50 * 1024 * 1024;
    const oversizedFiles = selectedFiles.filter(
      (file) => file.size > maxSizeBytes,
    );

    if (oversizedFiles.length > 0) {
      this.setState({
        docErrorMessageResult:
          "Some files exceed the 50MB limit. Choose smaller files.",
      });
      return;
    }

    // Debugging output to ensure files are being processed correctly
    // console.log("Selected Files: ", selectedFiles);
    // console.log("Current add_pictures in state: ", this.state.result_documents);

    // Append new files to existing array
    this.setState((prevState) => {
      const updatedPictures = [...prevState.result_documents, ...selectedFiles];
      // console.log("Updated Pictures: ", updatedPictures);
      // **Limit total files to 5**
      if (updatedPictures.length > 1) {
        return {
          docErrorMessageResult: "You can upload a maximum of 1 files.",
        };
      }
      return {
        result_documents: updatedPictures,
        docErrorMessageResult: "", // Clear error message
        result_documents_names: updatedPictures.map((file) => file.name),
      };
    });
  };

  fieldValidationUsername = () => {
    let {
      title,
      description,
      subpoena_ren_no,
      tags,
      comments,
      optionsSelected,
      requester_address,
      requester_phone,
      requester_name,
      requester_type,
      office_devision,
      requester_contact_name,
      requester_contact_title,
      requester_email,
      legal_authority_cited,
      request_type,
    } = this.state;

    if (requester_name === "") {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "Requester Name / Agency is required.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (office_devision === "") {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "Office / Division is required.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (requester_contact_name === "") {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "Contact person name is required.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (requester_address === "") {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "Complete address is required.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (requester_phone === "") {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "Phone number is required.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (!this.isPhoneValid(requester_phone)) {
      this.setState({
        errorMessageTitle: "Invalid Phone",
        errorMessage: "Invalid phone format.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (requester_email === "") {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "Email address is required.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (ValidateEmail(requester_email) === false) {
      this.setState({
        errorMessageTitle: "Invalid Email",
        errorMessage: "Please enter valid email address.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (title === "") {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "Title is required.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (subpoena_ren_no === "") {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "Reference # is required.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (optionsSelected.length === 0) {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "Please choose at least one option.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } /*else if (!tags || tags.length === 0) {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "DID(s) are required.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    }*/ else if (description === "") {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "Description is required.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (comments === "") {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "Comments are required.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else {
      this.setState({
        errorMessageTitle: "",
        errorMessage: "",
        disabled: true,
      });
    }
    return true;
  };

  fieldValidationRequester = () => {
    let {
      requester_address,
      requester_phone,
      requester_name,
      office_devision,
      requester_contact_name,
      requester_email,
      request_type,
      request_type_other,
    } = this.state;

    if (requester_name === "") {
      this.setState({
        errorMessageRequesterTitle: "Missing Field",
        errorMessageRequester: "Requester Name / Agency is required.",
        requester_info_button: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (office_devision === "") {
      this.setState({
        errorMessageRequesterTitle: "Missing Field",
        errorMessageRequester: "Office / Division is required.",
        requester_info_button: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (requester_contact_name === "") {
      this.setState({
        errorMessageRequesterTitle: "Missing Field",
        errorMessageRequester: "Contact person name is required.",
        requester_info_button: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (requester_address === "") {
      this.setState({
        errorMessageRequesterTitle: "Missing Field",
        errorMessageRequester: "Complete address is required.",
        requester_info_button: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (requester_phone === "") {
      this.setState({
        errorMessageRequesterTitle: "Missing Field",
        errorMessageRequester: "Phone number is required.",
        requester_info_button: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (!this.isPhoneValid(requester_phone)) {
      this.setState({
        errorMessageRequesterTitle: "Invalid Phone",
        errorMessageRequester: "Invalid phone format.",
        requester_info_button: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (requester_email === "") {
      this.setState({
        errorMessageRequesterTitle: "Missing Field",
        errorMessageRequester: "Email address is required.",
        requester_info_button: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (ValidateEmail(requester_email) === false) {
      this.setState({
        errorMessageRequesterTitle: "Invalid Email",
        errorMessageRequester: "Please enter valid email address.",
        requester_info_button: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (request_type !== "" && request_type === "Other") {
      if (request_type_other === "") {
        this.setState({
          errorMessageRequesterTitle: "Missing Other Type",
          errorMessageRequester: "Please specify the `Other` type of request.",
          requester_info_button: false,
        });
        document
          .getElementById("Support_Block")
          ?.scrollIntoView({ top: 0, behavior: "smooth" });
        return false;
      }
    } else {
      this.setState({
        errorMessageRequesterTitle: "",
        errorMessageRequester: "",
        //requester_info_button: false,
      });
    }
    return true;
  };

  fieldValidationRequest = () => {
    let { title_edit, subpoena_ren_no_edit, description } = this.state;

    if (title_edit === "") {
      this.setState({
        errorMessageRequestTitle: "Missing Field",
        errorMessageRequest: "Subject is required.",
        request_info_button: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (subpoena_ren_no_edit === "") {
      this.setState({
        errorMessageRequestTitle: "Missing Field",
        errorMessageRequest: "Reference # is required.",
        request_info_button: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (description === "") {
      this.setState({
        errorMessageRequestTitle: "Missing Field",
        errorMessageRequest: "Description is required.",
        request_info_button: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else {
      this.setState({
        errorMessageRequestTitle: "",
        errorMessageRequest: "",
        //requester_info_button: false,
      });
    }
    return true;
  };

  fieldValidationSought = () => {
    let { optionsSelected } = this.state;

    if (optionsSelected.length === 0) {
      this.setState({
        errorMessageSoughtTitle: "Missing Field",
        errorMessageSought:
          "Please choose at least one option from records sought.",
        records_sought_button: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } /*else if (!tags || tags.length === 0) {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "DID(s) are required.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    }*/ else {
      this.setState({
        errorMessageSoughtTitle: "",
        errorMessageSought: "",
      });
    }
    return true;
  };

  updateRequesterInfo = async () => {
    let {
      report_id,
      requester_address,
      requester_phone,
      requester_name,
      requester_type,
      office_devision,
      requester_contact_name,
      requester_contact_title,
      requester_email,
      legal_authority_cited,
      request_type,
      notifyRequester,
      request_type_other,
    } = this.state;
    this.setState({
      requester_info_button: true,
      successMessageRequester: "",
      errorMessageRequesterTitle: "",
      errorMessageRequester: "",
    });
    if (this.fieldValidationRequester() === true) {
      let notify = notifyRequester ? "true" : "false";

      const saveResponce = await updateRequesterInfo(
        auth.getAccount(),
        auth.getToken(),
        report_id,
        requester_address,
        requester_phone,
        requester_name,
        requester_type,
        office_devision,
        requester_contact_name,
        requester_contact_title,
        requester_email,
        legal_authority_cited,
        request_type,
        notify,
        auth.getUserType(),
        auth.getSubUserAccount(),
        request_type_other,
      );
      console.log("updateRequesterInfo: ", saveResponce.data);
      if (
        saveResponce.data.status === 403 ||
        saveResponce.data.errors === "authentication missing" ||
        saveResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        saveResponce.data.status === 404 &&
        saveResponce.data.message === "not_found"
      ) {
        this.setState({
          errorMessageRequesterTitle: "Error",
          errorMessageRequester:
            "There is some error while updating the requester information.",
          successMessageRequester: "",
          requester_info_button: false,
        });
        document
          .getElementById("Support_Block")
          ?.scrollIntoView({ top: 0, behavior: "smooth" });
      } else if (saveResponce.data.status === 200) {
        this.setState({
          successMessageRequester:
            "Requester information updated successfully.",
          errorMessageRequesterTitle: "",
          errorMessageRequester: "",
          requester_info_button: false,
          notifyRequester: false,
        });
        document
          .getElementById("Support_Block")
          ?.scrollIntoView({ top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.getSingleRequest(report_id);
        }, 4000);
      } else {
        this.setState({
          errorMessageRequesterTitle: "Error",
          errorMessageRequester:
            "There is some error while updating the requester information.",
          requester_info_button: false,
        });
        document
          .getElementById("Support_Block")
          ?.scrollIntoView({ top: 0, behavior: "smooth" });
      }
      setTimeout(() => {
        this.setState({
          errorMessageRequesterTitle: "",
          errorMessageRequester: "",
          successMessageRequester: "",
          requester_info_button: false,
        });
      }, 4000);
    }
  };

  updateRequestInfo = async () => {
    let {
      title_edit,
      description,
      start_date,
      end_date,
      report_id,
      report_params,
      report_url_id,
      publish_report,
      subpoena_ren_no_edit,
      extra_params_array,
      notifyRequest,
      dueDate,
    } = this.state;
    this.setState({
      request_info_button: true,
      successMessageRequest: "",
      errorMessageRequestTitle: "",
      errorMessageRequest: "",
    });
    if (this.fieldValidationRequest() === true) {
      let notify = notifyRequest ? "true" : "false";

      const saveResponce = await updateRequestInfo(
        auth.getAccount(),
        auth.getToken(),
        report_id,
        title_edit,
        description,
        start_date,
        end_date,
        report_params,
        report_url_id,
        publish_report,
        subpoena_ren_no_edit,
        JSON.stringify(extra_params_array),
        notify,
        dueDate,
        auth.getUserType(),
        auth.getSubUserAccount(),
      );
      console.log("updateRequesterInfo: ", saveResponce.data);
      if (
        saveResponce.data.status === 403 ||
        saveResponce.data.errors === "authentication missing" ||
        saveResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        saveResponce.data.status === 404 &&
        saveResponce.data.message === "not_found"
      ) {
        this.setState({
          errorMessageRequestTitle: "Error",
          errorMessageRequest:
            "There is some error while updating the request information & action.",
          successMessageRequest: "",
          request_info_button: false,
        });
        document
          .getElementById("Support_Block")
          ?.scrollIntoView({ top: 0, behavior: "smooth" });
      } else if (saveResponce.data.status === 200) {
        this.setState({
          successMessageRequest:
            "Request information and actions updated successfully.",
          errorMessageRequestTitle: "",
          errorMessageRequest: "",
          request_info_button: false,
          notifyRequest: false,
        });
        document
          .getElementById("Support_Block")
          ?.scrollIntoView({ top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.getSingleRequest(report_id);
        }, 4000);
      } else {
        this.setState({
          errorMessageRequestTitle: "Error",
          errorMessageRequest:
            "There is some error while updating the request information & action.",
          request_info_button: false,
        });
        document
          .getElementById("Support_Block")
          ?.scrollIntoView({ top: 0, behavior: "smooth" });
      }
      setTimeout(() => {
        this.setState({
          request_info_button: false,
          successMessageRequest: "",
          errorMessageRequestTitle: "",
          errorMessageRequest: "",
        });
      }, 4000);
    }
  };

  updateRecordSought = async () => {
    let {
      add_picture,
      add_picture_name,
      report_id,
      added_file,
      add_pictures,
      tags,
      enableDids,
      optionsSelected,
      result_documents,
      added_file_did,
    } = this.state;

    this.setState({
      records_sought_button: true,
      errorMessageSoughtTitle: "",
      errorMessageSought: "",
      successMessageSought: "",
    });
    //console.log("added_file: ", added_file);
    if (this.fieldValidationSought() === true) {
      const formData = new FormData();
      formData.append("token", process.env.REACT_APP_API_TOKEN);
      formData.append("api_accountno", process.env.REACT_APP_API_ACCOUNTNO);
      formData.append("accountno", auth.getAccount());

      formData.append("report_id", report_id);

      formData.append("added_file", JSON.stringify(added_file));

      formData.append("enableDids", enableDids);
      formData.append("added_file_did", added_file_did);
      formData.append("dids", JSON.stringify(tags));

      //Requester Information

      formData.append(
        "notifyCheckBox",
        this.state.notifyRecordsSought ? "true" : "false",
      );
      formData.append("user_type", auth.getUserType());
      formData.append("sub_accountno", auth.getSubUserAccount());
      formData.append("is_supoena_user", auth.getSubpoenaType());
      formData.append("requested_options", JSON.stringify(optionsSelected));
      add_pictures.forEach((file) => {
        formData.append("files", file);
      });

      try {
        axios
          .post(
            process.env.REACT_APP_API_URL + "subpoena/update_subpoena_records_sought",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Credentials": true,
              },
            },
            {},
          )
          .then((response) => {
            console.log("edit_subpoena_records_sought: ", response.data);
            if (
              response.data.status === 404 &&
              response.data.message === "no_record"
            ) {
              this.setState({
                errorMessageSoughtTitle: "Missing Request",
                errorMessageSought: "Request does not found.",
                records_sought_button: false,
                successMessageSought: "",
              });
              document
                .getElementById("Support_Block")
                ?.scrollIntoView({ top: 0, behavior: "smooth" });
              setTimeout(() => {
                this.setState({
                  errorMessageSought: "",
                });
              }, 4000);
            } else if (response.data.status === 403) {
              this.setState({
                errorMessageSought: response.data.message,
                errorMessageSoughtTitle: "System Error",
                records_sought_button: false,
                successMessageSought: "",
              });
              document
                .getElementById("Support_Block")
                ?.scrollIntoView({ top: 0, behavior: "smooth" });
              setTimeout(() => {
                this.setState({
                  errorMessageSought: "",
                });
              }, 4000);
            } else if (
              response.data.status === 200 &&
              response.data.message === "success"
            ) {
              this.setState({
                successMessageSought:
                  "Records sought has been updated successfully.",
                errorMessageSought: "",
                records_sought_button: false,
                notifyRecordsSought: false,
              });
              document
                .getElementById("Support_Block")
                ?.scrollIntoView({ top: 0, behavior: "smooth" });
              setTimeout(() => {
                this.setState({
                  errorMessageSought: "",
                  successMessageSought: "",
                });
                this.getSingleRequest(report_id);
              }, 4000);

              //this.nextStep();
            } else {
              this.setState({
                errorMessageSoughtTitle: "System Error",
                errorMessageSought:
                  "There is some error while updating the records sought.",
                successMessageSought: "",
                records_sought_button: false,
              });
              document
                .getElementById("Support_Block")
                ?.scrollIntoView({ top: 0, behavior: "smooth" });
              setTimeout(() => {
                this.setState({
                  errorMessageSought: "",
                });
              }, 4000);
            }
            this.setState({
              records_sought_button: false,
            });
          });
      } catch (error) {
        this.setState({
          errorMessageSoughtTitle: "System Error",
          errorMessageSought:
            "There is some error while updating the records sought.",
          successMessageSought: "",
          records_sought_button: false,
        });
        document
          .getElementById("Support_Block")
          ?.scrollIntoView({ top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.setState({
            errorMessageSought: "",
          });
        }, 4000);
      }
    }
  };

  updateDocuments = async () => {
    let {
      report_id,
      added_file,
      result_documents,
      notifyUpdateDocuments,
      choose_option_title,
    } = this.state;

    this.setState({
      update_documents_buttons: true,
      errorMessageDocumentsTitle: "",
      errorMessageDocuments: "",
      successMessageDocuments: "",
    });
    console.log("added_file: ", added_file);
    if (result_documents.length > 0 || added_file.length > 0) {
      const formData = new FormData();
      formData.append("token", process.env.REACT_APP_API_TOKEN);
      formData.append("api_accountno", process.env.REACT_APP_API_ACCOUNTNO);
      formData.append("accountno", auth.getAccount());
      formData.append("report_id", report_id);
      formData.append("choose_option_title", choose_option_title);
      formData.append("added_file", JSON.stringify(added_file));
      formData.append(
        "notifyCheckBox",
        notifyUpdateDocuments ? "true" : "false",
      );
      formData.append("user_type", auth.getUserType());
      formData.append("sub_accountno", auth.getSubUserAccount());
      formData.append("is_supoena_user", auth.getSubpoenaType());
      result_documents.forEach((file) => {
        formData.append("files2", file);
      });

      try {
        axios
          .post(
            process.env.REACT_APP_API_URL + "subpoena/update_subpoena_result_documents",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Credentials": true,
              },
            },
            {},
          )
          .then((response) => {
            console.log("response: ", response.data);
            if (
              response.data.status === 404 &&
              response.data.message === "no_record"
            ) {
              this.setState({
                errorMessageDocumentsTitle: "Missing Request",
                errorMessageDocuments: "Request does not found.",
                update_documents_buttons: false,
                successMessageDocuments: "",
              });
              document
                .getElementById("Support_Block")
                ?.scrollIntoView({ top: 0, behavior: "smooth" });
              setTimeout(() => {
                this.setState({
                  errorMessage: "",
                });
              }, 4000);
            } else if (response.data.status === 403) {
              this.setState({
                errorMessageDocuments: response.data.message,
                errorMessageDocumentsTitle: "System Error",
                update_documents_buttons: false,
                successMessageDocuments: "",
              });
              document
                .getElementById("Support_Block")
                ?.scrollIntoView({ top: 0, behavior: "smooth" });
              setTimeout(() => {
                this.setState({
                  errorMessageDocuments: "",
                });
              }, 4000);
            } else if (
              response.data.status === 200 &&
              response.data.message === "success"
            ) {
              this.setState({
                successMessageDocuments:
                  "Your documents has been updated successfully. Please wait while we are updating the documents list.",
                errorMessageDocuments: "",
                notifyUpdateDocuments: false,
              });
              document
                .getElementById("Support_Block")
                ?.scrollIntoView({ top: 0, behavior: "smooth" });
              setTimeout(() => {
                this.setState({
                  successMessageDocuments: "",
                  errorMessageDocuments: "",
                  result_documents: [],
                  result_documents_names: [],
                  update_documents_buttons: false,
                });
                this.getSingleRequest(report_id);
              }, 4000);

              //this.nextStep();
            } else {
              this.setState({
                errorMessageDocumentsTitle: "System Error",
                errorMessageDocuments:
                  "There is some error while updating the documents.",

                successMessageDocuments: "",
                update_documents_buttons: false,
              });
              document
                .getElementById("Support_Block")
                ?.scrollIntoView({ top: 0, behavior: "smooth" });
              setTimeout(() => {
                this.setState({
                  errorMessageDocuments: "",
                });
              }, 4000);
            }
          });
      } catch (error) {
        this.setState({
          errorMessageDocumentsTitle: "System Error",
          errorMessageDocuments:
            "There is some error while updating the documents.",
          successMessageDocuments: "",
          update_documents_buttons: false,
        });
        document
          .getElementById("Support_Block")
          ?.scrollIntoView({ top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.setState({
            errorMessageDocuments: "",
          });
        }, 4000);
      }
    } else {
      this.setState({
        errorMessageDocumentsTitle: "Missing Documents",
        errorMessageDocuments:
          "The new document and the previously uploaded documents are missing.",
        update_documents_buttons: false,
        successMessageDocuments: "",
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      setTimeout(() => {
        this.setState({
          errorMessageDocuments: "",
        });
      }, 4000);
    }
  };

  addComments = async () => {
    let { report_id, comments, emailCcs, notifyCheckBox } = this.state;

    this.setState({
      add_comments_button: true,
      errorMessageComments: "",
      errorMessageCommentsTitle: "",
      successMessageComments: "",
    });
    if (comments !== "") {
      let notify = notifyCheckBox ? "true" : "false";

      const saveResponce = await addRequestComments(
        auth.getAccount(),
        auth.getToken(),
        report_id,
        comments,
        JSON.stringify(emailCcs),
        notify,
        auth.getUserType(),
        auth.getSubUserAccount(),
      );
      console.log("addRequestComments: ", saveResponce.data);
      if (
        saveResponce.data.status === 403 ||
        saveResponce.data.errors === "authentication missing" ||
        saveResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        saveResponce.data.status === 404 &&
        saveResponce.data.message === "not_found"
      ) {
        this.setState({
          errorMessageCommentsTitle: "Missing Request",
          errorMessageComments: "The request does not found..",
          successMessageComments: "",
          add_comments_button: false,
        });
        document
          .getElementById("Support_Block")
          ?.scrollIntoView({ top: 0, behavior: "smooth" });
      } else if (saveResponce.data.status === 200) {
        this.setState({
          successMessageComments: "Comments added successfully.",
          errorMessageCommentsTitle: "",
          errorMessageComments: "",
          add_comments_button: false,
          notifyCheckBox: false,
          comments: "",
          emailCcs: [],
          inputValueCc: "",
          ccErrorMessage: "",
        });
        document
          .getElementById("Support_Block")
          ?.scrollIntoView({ top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.getSingleRequest(report_id);
        }, 4000);
      } else {
        this.setState({
          errorMessageCommentsTitle: "Error",
          errorMessageComments:
            "There is some error while adding the comments.",
          add_comments_button: false,
        });
        document
          .getElementById("Support_Block")
          ?.scrollIntoView({ top: 0, behavior: "smooth" });
      }
    } else {
      this.setState({
        add_comments_button: false,
        successMessageComments: "",
        errorMessageCommentsTitle: "Missing Field",
        errorMessageComments: "Comments are required.",
      });
    }
    setTimeout(() => {
      this.setState({
        add_comments_button: false,
        successMessageComments: "",
        errorMessageCommentsTitle: "",
        errorMessageComments: "",
      });
    }, 4000);
  };

  submitRequest = async (e) => {
    e.preventDefault();
    let {
      title,
      description,
      start_date,
      end_date,
      add_picture,
      add_picture_name,
      report_id,
      added_file,
      add_pictures,
      report_params,
      report_url_id,
      publish_report,
      tags,
      subscriber_settings,
      billing_settings,
      other_did_settings,
      contract_settings,
      communication_settings,
      payment_settings,
      subpoena_ren_no,
      comments,
      enableDids,
      extra_params_array,
      optionsSelected,
      emailCcs,
      result_documents,
      added_file_did,
      requester_address,
      requester_phone,
      requester_name,
      requester_type,
      office_devision,
      requester_contact_name,
      requester_contact_title,
      requester_email,
      legal_authority_cited,
      request_type,
    } = this.state;

    this.setState({
      verifyPasswordButton: true,
      disabled: true,
      errorMessageTitle: "",
      errorMessage: "",
    });
    console.log("added_file: ", added_file);
    if (this.fieldValidationUsername() === true) {
      const formData = new FormData();
      formData.append("token", process.env.REACT_APP_API_TOKEN);
      formData.append("api_accountno", process.env.REACT_APP_API_ACCOUNTNO);
      formData.append("accountno", auth.getAccount());
      formData.append("report_params", report_params);
      formData.append("report_url_id", report_url_id);
      formData.append("title", title);
      formData.append("description", description);
      formData.append("comments", comments);
      formData.append("start_date", start_date);
      formData.append("end_date", end_date);
      formData.append("report_id", report_id);
      formData.append("publish_report", publish_report);
      formData.append("added_file", JSON.stringify(added_file));
      formData.append("subpoena_ren_no", subpoena_ren_no);
      formData.append("enableDids", enableDids);
      formData.append("added_file_did", added_file_did);
      formData.append("dids", JSON.stringify(tags));
      formData.append("extra_params", JSON.stringify(extra_params_array));
      formData.append(
        "subscriber_settings",
        subscriber_settings ? "true" : "false",
      );
      formData.append("billing_settings", billing_settings ? "true" : "false");
      formData.append(
        "other_did_settings",
        other_did_settings ? "true" : "false",
      );
      formData.append(
        "contract_settings",
        contract_settings ? "true" : "false",
      );
      formData.append(
        "communication_settings",
        communication_settings ? "true" : "false",
      );
      //Requester Information
      formData.append("requester_address", requester_address);
      formData.append("requester_phone", requester_phone);
      formData.append("requester_name", requester_name);
      formData.append("requester_type", requester_type);
      formData.append("office_devision", office_devision);
      formData.append("requester_contact_name", requester_contact_name);
      formData.append("requester_contact_title", requester_contact_title);
      formData.append("requester_email", requester_email);
      formData.append("legal_authority_cited", legal_authority_cited);
      formData.append("request_type", request_type);

      formData.append(
        "notifyCheckBox",
        this.state.notifyCheckBox ? "true" : "false",
      );

      formData.append("payment_settings", payment_settings ? "true" : "false");
      formData.append("user_type", auth.getUserType());
      formData.append("sub_accountno", auth.getSubUserAccount());
      formData.append("is_supoena_user", auth.getSubpoenaType());
      formData.append("requested_options", JSON.stringify(optionsSelected));
      formData.append("email_cc", JSON.stringify(emailCcs));
      add_pictures.forEach((file) => {
        formData.append("files", file);
      });
      result_documents.forEach((file) => {
        formData.append("files2", file);
      });

      console.log("notifyCheckBox: ", this.state.notifyCheckBox.toString());

      try {
        axios
          .post(
            process.env.REACT_APP_API_URL + "subpoena/edit_subpoena_report_request",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Credentials": true,
              },
            },
            {},
          )
          .then((response) => {
            console.log("response: ", response.data);
            if (
              response.data.status === 404 &&
              response.data.message === "no_record"
            ) {
              this.setState({
                errorMessageTitle: "Missing Client",
                errorMessage: "Client does not found.",
                disabled: false,
                submitRfq_button_loader: false,
                successMessage: "",
              });
              document
                .getElementById("Support_Block")
                ?.scrollIntoView({ top: 0, behavior: "smooth" });
              setTimeout(() => {
                this.setState({
                  errorMessage: "",
                });
              }, 4000);
            } else if (response.data.status === 403) {
              this.setState({
                errorMessage: response.data.message,
                disabled: false,
                submitRfq_button_loader: false,
                successMessage: "",
              });
              document
                .getElementById("Support_Block")
                ?.scrollIntoView({ top: 0, behavior: "smooth" });
              setTimeout(() => {
                this.setState({
                  errorMessage: "",
                });
              }, 4000);
            } else if (
              response.data.status === 200 &&
              response.data.message === "success"
            ) {
              this.setState({
                successMessage: "Your request has been updated successfully.",
                errorMessage: "",
                final_login_url: response.data.login_url,
                showLoginButton: true,
              });
              document
                .getElementById("Support_Block")
                ?.scrollIntoView({ top: 0, behavior: "smooth" });
              setTimeout(() => {
                window.location.replace("/Compliance");
              }, 3000);

              //this.nextStep();
            } else {
              this.setState({
                errorMessageTitle: "System Error",
                errorMessage: "There is some error while updated the request.",
                disabled: false,
                successMessage: "",
                submitRfq_button_loader: false,
              });
              document
                .getElementById("Support_Block")
                ?.scrollIntoView({ top: 0, behavior: "smooth" });
              setTimeout(() => {
                this.setState({
                  errorMessage: "",
                });
              }, 4000);
            }
            this.setState({
              submitRfq_button_loader: false,
            });
          });
      } catch (error) {
        this.setState({
          errorMessageTitle: "System Error",
          errorMessage: "There is some error while updated the request.",
          disabled: false,
          successMessage: "",
          submitRfq_button_loader: false,
        });
        document
          .getElementById("Support_Block")
          ?.scrollIntoView({ top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.setState({
            errorMessage: "",
          });
        }, 4000);
      }
    }
  };

  handleRemoveFile = (index) => {
    this.setState((prevState) => {
      const updatedPictures = [...prevState.add_pictures];
      const updatedNames = [...prevState.add_picture_names];

      // Remove file from both arrays by index
      updatedPictures.splice(index, 1);
      updatedNames.splice(index, 1);

      return {
        add_pictures: updatedPictures,
        add_picture_names: updatedNames,
      };
    });
  };

  handleRemoveFileResult = (index) => {
    this.setState((prevState) => {
      const updatedPictures = [...prevState.result_documents];
      const updatedNames = [...prevState.result_documents_names];

      // Remove file from both arrays by index
      updatedPictures.splice(index, 1);
      updatedNames.splice(index, 1);

      return {
        result_documents: updatedPictures,
        result_documents_names: updatedNames,
      };
    });
  };

  deleteResultModal = async (file_index, file_id, requested_option) => {
    const { report_id, requester_email } = this.state;

    this.setState({
      deleteErrorMessage: "",
      deleteSuccessMessage: "",
      notifyDeletion: false,
      delete_file_index: file_index,
      delete_file_id: file_id,
      delete_requested_option: requested_option,
    });
    window.$("#modalDeleteResult").modal("show");
  };

  deleteResultDocument = async () => {
    const {
      report_id,
      delete_file_index,
      delete_file_id,
      delete_requested_option,
    } = this.state;

    this.setState({
      deleteErrorMessage: "",
      deleteSuccessMessage: "",
      notifyDeletion: true,
    });

    const saveResponce = await deleteResultDocument(
      auth.getAccount(),
      auth.getToken(),
      report_id,

      delete_file_id,
      delete_requested_option,
      auth.getUserType(),
      auth.getSubUserAccount(),
    );
    console.log("deleteResultDocument: ", saveResponce.data);
    if (
      saveResponce.data.status === 403 ||
      saveResponce.data.errors === "authentication missing" ||
      saveResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      saveResponce.data.status === 404 &&
      saveResponce.data.message === "not_found"
    ) {
      this.setState({
        deleteErrorMessage: "The request does not found..",
        deleteSuccessMessage: "",
        notifyDeletion: false,
      });
    } else if (saveResponce.data.status === 200) {
      this.setState({
        deleteErrorMessage: "",
        deleteSuccessMessage:
          "Result file deleted successfully. Please wait while we are closing this popup.",
        //notifyDeletion: false,
      });
      this.handleRemoveAddedFile(delete_file_index);
      setTimeout(() => {
        this.getSingleRequest(report_id);
        window.$("#modalDeleteResult").modal("hide");
      }, 4000);
    } else {
      this.setState({
        deleteErrorMessage:
          "There is some error while deleting the result document.",
        deleteSuccessMessage: "",
        notifyDeletion: false,
      });
    }
  };

  handleRemoveAddedFile = (index) => {
    // console.log("handleRemoveAddedFile: ", this.state.added_file);
    this.setState((prevState) => {
      const updatedNames = [...prevState.added_file];
      // Remove file from both arrays by index
      updatedNames.splice(index, 1);
      console.log("handleRemoveAddedFileAfter: ", updatedNames);
      return {
        added_file: updatedNames,
      };
    });
  };

  downloadPdf = async (d_f_name) => {
    //var url = d_f_name;
    //let file_name = this.extractFileNameFromUrl(d_f_name);
    var url = APP_LIVE_URL + "files_data/pages/" + d_f_name;
    //console.log("downloadPdfRfq: ", url);
    fetch(url)
      .then((x) => x.blob())
      .then((b) => {
        // console.log("B INSTANCE", b instanceof Blob);
        const url = window.URL.createObjectURL(b);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.download = d_f_name;
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        this.setState({
          errorMessage: "There is some error while downloading the attachment.",
        });
        setTimeout(() => {
          this.setState({ errorMessage: "" });
        }, 4000);
        // Handle any errors that occurred during the fetch
        console.error("Fetch error:", error);
      });
  };

  downloadPdfRfq = async (d_f_name) => {
    var url = d_f_name;
    //let file_name = this.extractFileNameFromUrl(d_f_name);
    url = APP_LIVE_URL + "files_data/kyc_signup/" + d_f_name;
    //console.log("downloadPdfRfq: ", url);
    fetch(url)
      .then((x) => x.blob())
      .then((b) => {
        // console.log("B INSTANCE", b instanceof Blob);
        const url = window.URL.createObjectURL(b);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.download = d_f_name;
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        this.setState({
          errorMessage: "There is some error while downloading the attachment.",
        });
        setTimeout(() => {
          this.setState({ errorMessage: "" });
        }, 4000);
        // Handle any errors that occurred during the fetch
        console.error("Fetch error:", error);
      });
  };

  handleOptionChange = (event) => {
    const value = event.target.value;
    this.setState({
      enableDids: event.target.value,
    });
  };

  handleChangeTextarea = (event) => {
    const input = event.target.value;

    // Limit to 1000 characters
    if (input.length <= 1000) {
      this.setState({ description: input });
    }
  };

  makeURLString = () => {
    const { report_url_id } = this.state;
    if (report_url_id !== "") {
      let { report_params } = this.state;

      // Parse if it's a string
      if (typeof report_params === "string") {
        try {
          report_params = JSON.parse(report_params);
        } catch (e) {
          console.error("Failed to parse report_params JSON:", e);
          report_params = {};
        }
      }

      const queryParams = [`dash_id=${encodeURIComponent(report_url_id)}`];

      if (report_params && typeof report_params === "object") {
        for (let key in report_params) {
          if (!report_params.hasOwnProperty(key)) continue;

          let value = report_params[key];
          if (Array.isArray(value)) value = value[0];

          if (value !== undefined && value !== null && value !== "") {
            queryParams.push(
              `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
            );
          }
        }
      }

      const finalQueryString = `?${queryParams.join("&")}`;
      // console.log("FINAL QUERY STRING:", finalQueryString);
      this.setState({ extra_params: finalQueryString });
    }
  };

  handleCheckboxChange = (index) => {
    const options = [...this.state.subpoenaOptions];
    options[index].checked = !options[index].checked;

    const selected = options
      .filter((opt) => opt.checked)
      .map(({ name, value }) => ({ name, value }));

    this.setState({ subpoenaOptions: options, optionsSelected: selected });
  };

  handleDeleteOption = (index) => {
    const options = this.state.subpoenaOptions.filter((_, i) => i !== index);
    const selected = options
      .filter((opt) => opt.checked)
      .map(({ name, value }) => ({ name, value }));

    this.setState({ subpoenaOptions: options, optionsSelected: selected });
  };

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleAddOption = () => {
    const { newName, newValue, subpoenaOptions } = this.state;
    console.log("newName: ", newName);
    if (newName.trim()) {
      const newOption = { name: newName, value: newName, checked: false };
      this.setState({
        subpoenaOptions: [...subpoenaOptions, newOption], // appended to array
        newName: "",
        newValue: "",
      });
    }
  };

  handleChangeTagCc = (event) => {
    const { value } = event.target;
    this.setState({ inputValueCc: value, ccErrorMessage: "" });
  };

  handlePasteCc = (event) => {
    event.preventDefault();
    const pastedText = event.clipboardData.getData("text");
    this.setState({ inputValueCc: pastedText }, this.addCcEmails);
  };

  handleKeyDownCc = (event) => {
    const { inputValueCc, emailCcs } = this.state;
    
    if (event.key === "Enter" || event.key === ",") {
      event.preventDefault();
      this.addCcEmails();
    } else if (event.key === "Backspace" && !inputValueCc && emailCcs.length > 0) {
      // Remove the last email when backspace is pressed and input is empty
      event.preventDefault();
      this.setState((prevState) => ({
        emailCcs: prevState.emailCcs.slice(0, -1),
      }));
    }
  };

  addCcEmails = () => {
    const { inputValueCc, emailCcs } = this.state;
    if (!inputValueCc.trim()) return;

    // Split input by commas and remove extra spaces
    let newEmails = inputValueCc
      .split(",")
      .map((email) => email.trim())
      .filter((email) => email);

    // Keep only valid emails
    newEmails = newEmails.filter((email) => this.validateEmails(email));

    if (newEmails.length === 0) {
      this.setState({ ccErrorMessage: "Please enter valid email(s)." });
      return;
    }

    // Remove duplicates (within input + already existing)
    newEmails = [...new Set(newEmails)].filter(
      (email) => !emailCcs.includes(email),
    );

    // Check maximum 5
    if (emailCcs.length + newEmails.length > 5) {
      this.setState({ ccErrorMessage: "Maximum 5 emails allowed!" });
      return;
    }

    this.setState((prevState) => ({
      emailCcs: [...prevState.emailCcs, ...newEmails],
      inputValueCc: "",
      ccErrorMessage: "",
    }));
  };

  handleRemoveTagCc = (index) => {
    this.setState((prevState) => ({
      emailCcs: prevState.emailCcs.filter((_, i) => i !== index),
    }));
  };

  handleRemoveTagCcApproval = (index) => {
    this.setState((prevState) => ({
      emailCcsApproval: prevState.emailCcsApproval.filter(
        (_, i) => i !== index,
      ),
    }));
  };

  handleChangeTagCcApproval = (event) => {
    const { value } = event.target;
    this.setState({ inputValueCcApproval: value, ccErrorMessageApproval: "" });
  };

  handlePasteCcApproval = (event) => {
    event.preventDefault();
    const pastedText = event.clipboardData.getData("text");
    this.setState({ inputValueCcApproval: pastedText }, this.addCcEmails);
  };

  handleKeyDownCcApproval = (event) => {
    const { inputValueCcApproval, emailCcsApproval } = this.state;
    
    if (event.key === "Enter" || event.key === ",") {
      event.preventDefault();
      this.addCcEmailsApproval();
    } else if (event.key === "Backspace" && !inputValueCcApproval && emailCcsApproval.length > 0) {
      // Remove the last email when backspace is pressed and input is empty
      event.preventDefault();
      this.setState((prevState) => ({
        emailCcsApproval: prevState.emailCcsApproval.slice(0, -1),
      }));
    }
  };

  addCcEmailsApproval = () => {
    const { inputValueCcApproval, emailCcsApproval } = this.state;
    if (!inputValueCcApproval.trim()) return;

    // Split input by commas and remove extra spaces
    let newEmails = inputValueCcApproval
      .split(",")
      .map((email) => email.trim())
      .filter((email) => email);

    // Keep only valid emails
    newEmails = newEmails.filter((email) => this.validateEmails(email));

    if (newEmails.length === 0) {
      this.setState({ ccErrorMessageApproval: "Please enter valid email(s)." });
      return;
    }

    // Remove duplicates (within input + already existing)
    newEmails = [...new Set(newEmails)].filter(
      (email) => !emailCcsApproval.includes(email),
    );

    // Check maximum 5
    if (emailCcsApproval.length + newEmails.length > 5) {
      this.setState({ ccErrorMessageApproval: "Maximum 5 emails allowed!" });
      return;
    }

    this.setState((prevState) => ({
      emailCcsApproval: [...prevState.emailCcsApproval, ...newEmails],
      inputValueCcApproval: "",
      ccErrorMessageApproval: "",
    }));
  };

  handleRemoveTagCcApproval = (index) => {
    this.setState((prevState) => ({
      emailCcsApproval: prevState.emailCcsApproval.filter(
        (_, i) => i !== index,
      ),
    }));
  };

  validateEmails = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  handleAddressSelect = async (place) => {
    const { description } = place.value;
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          description,
        )}&key=${process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}`,
      );
      const data = await response.json();

      if (data.status === "OK") {
        const addressComponents = data.results[0].address_components;
        const formattedAddress = data.results[0].formatted_address;
        let city = null;
        let state = null;
        let country = null;
        let zipCode = null;
        let streetAddress = "";
        let neighborhood = null;
        let locality = null;
        let address2 = "";
        addressComponents.forEach((component) => {
          if (component.types.includes("neighborhood")) {
            neighborhood = component.long_name;
          } else if (component.types.includes("locality")) {
            locality = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.short_name;
          } else if (component.types.includes("country")) {
            country = component.long_name;
          } else if (component.types.includes("postal_code")) {
            zipCode = component.long_name;
          } else if (component.types.includes("subpremise")) {
            address2 = component.long_name;
          } else if (
            ![
              "neighborhood",
              "sublocality",
              "sublocality_level_1",
              "sublocality_level_2",
              "administrative_area_level_2",
              "administrative_area_level_3",
              "postal_code_suffix",
            ].includes(component.types[0])
          ) {
            if (streetAddress !== "") {
              streetAddress += " ";
            }
            streetAddress += component.long_name;
          }
        });
        // Check if neighborhood is part of the formatted address
        if (neighborhood && formattedAddress.includes(neighborhood)) {
          city = neighborhood;
        } else {
          city = locality;
        }
        this.setState({
          /*client_city: city && city !== "" ? city : "",
          client_state: state && state !== "" ? state : "",
          client_zip: zipCode && zipCode !== "" ? zipCode : "",
          client_country: country && country !== "" ? country : "",
          client_address:
            streetAddress && streetAddress !== "" ? streetAddress : "",
          client_address2: address2 && address2 !== "" ? address2 : "",*/
          requester_address: formattedAddress,
        });
      } else {
        console.error("Reverse geocoding request failed:", data.status);
      }
    } catch (error) {
      console.error("Error fetching reverse geocoding data:", error);
    }
  };

  getCustomSettings = async () => {
    try {
      const getCustomSetting_res = await getCustomSettings(
        auth.getAccount(),
        auth.getToken(),
      );
      //console.log("getCustomSetting_res: ", getCustomSetting_res.data);
      if (
        getCustomSetting_res.data.status === 200 &&
        getCustomSetting_res.data.data &&
        getCustomSetting_res.data.data.length > 0
      ) {
        this.setState({
          address_autocomplete:
            getCustomSetting_res.data.data[0].address_autocomplete || "Yes",
          address_validation:
            getCustomSetting_res.data.data[0].address_validation || "Yes",
        });
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  phoneUtil = PhoneNumberUtil.getInstance();

  isPhoneValid = (phone) => {
    try {
      return this.phoneUtil.isValidNumber(
        this.phoneUtil.parseAndKeepRawInput(phone),
      );
    } catch (error) {
      return false;
    }
  };

  handleFocus = () => {
    // Move cursor to the end of the input value
    const input = this.phoneInputRef.current;
    if (input) {
      const value = input.value;
      input.setSelectionRange(value.length, value.length);
    }
  };

  handleChangePhone = async (event) => {
    const { target } = event;
    let value = target.type === "radio" ? target.checked : target.value;
    const { name } = target;

    //console.log(name);
    this.setState({
      [name]: value,
    });
  };

  changeActiveTab = (tab) => {
    this.setState({
      activeTab: tab,
      //assignedLoader: true,
    });
  };

  approveReportModal = async () => {
    const { report_id, requester_email } = this.state;

    this.setState({
      approvalErrorMessage: "",
      approvalErrorMessageTitle: "",
      approvalSuccessMessage: "",
      notifyApproval: false,
      approval_requester_email: requester_email,
      approval_subpoena_id: report_id,
      approval_notes: "",
      emailCcsApproval: [],
      inputValueCcApproval: "",
      ccErrorMessageApproval: "",
      approve_client_button: false,
      approval_main_section: true,
    });
    window.$("#modalApproval").modal("show");
    setTimeout(() => {
      this.setState({
        approval_main_section: false,
      });
    }, 1500);
  };

  approve_subpoena_request = async () => {
    const {
      approval_requester_email,
      approval_subpoena_id,
      emailCcsApproval,
      notifyApproval,
      approval_notes,
    } = this.state;
    this.setState({
      approvalErrorMessage: "",
      approvalErrorMessageTitle: "",
      approvalSuccessMessage: "",
      ccErrorMessageApproval: "",
      approve_client_button: true,
    });
    let notifyApprovals = notifyApproval ? "true" : "false";

    const reportsData = await approveSubpoenaReport(
      auth.getAccount(),
      auth.getToken(),
      approval_subpoena_id,
      approval_requester_email,
      auth.getUserType(),
      auth.getSubUserAccount(),
      notifyApprovals,
      approval_notes,
      JSON.stringify(emailCcsApproval),
    );
    console.log("approveSubpoenaReport: ", reportsData.data);

    if (
      reportsData.data.status === 403 ||
      reportsData.data.errors === "authentication missing" ||
      reportsData.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      reportsData.data.status === 404 &&
      reportsData.data.message === "Report not found."
    ) {
      //window.location.replace("/error");
      this.setState({
        diabled: false,
        approvalErrorMessage: "Report not found.",
        approvalErrorMessageTitle: "Error",
        approvalSuccessMessage: "",
        approve_client_button: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
    } else if (
      reportsData.data.status === 200 &&
      reportsData.data.message === "success"
    ) {
      this.setState({
        approvalErrorMessage: "",
        approvalErrorMessageTitle: "",
        approvalSuccessMessage:
          "Request approved successfully. Please wait while we refresh the page.",
        //approve_client_button: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      setTimeout(() => {
        window.location.reload();
      }, 4000);
    } else {
      // console.log("Last: ", reportsData.data);
      this.setState({
        diabled: false,
        approvalErrorMessage:
          "There is some error while approving the request.",
        approvalErrorMessageTitle: "System Error",
        approvalSuccessMessage: "",
        approve_client_button: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
    }
  };

  approvalLogsModal = async () => {
    const { requester_email, report_id } = this.state;
    this.setState({
      approvalLogErrorMessage: "",
      approvalLogErrorMessageTitle: "",
      requester_email: requester_email,
      approval_subpoena_id: report_id,
      approval_logs_main_section: true,
    });
    window.$("#modalApprovalLogs").modal("show");
    const reportsData = await getApprovalLogs(
      auth.getAccount(),
      auth.getToken(),
      report_id,
      requester_email,
    );
    console.log("getApprovalLogs: ", reportsData.data);

    if (
      reportsData.data.status === 403 ||
      reportsData.data.errors === "authentication missing" ||
      reportsData.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      reportsData.data.status === 404 &&
      reportsData.data.message === "Report not found."
    ) {
      //window.location.replace("/error");
      this.setState({
        diabled: false,
        approvalLogErrorMessage: "Report not found.",
        approvalLogErrorMessageTitle: "Error",
        approval_logs_main_section: false,
      });
    } else if (
      reportsData.data.status === 404 &&
      reportsData.data.message === "not_found"
    ) {
      //window.location.replace("/error");
      this.setState({
        diabled: false,
        approvalLogErrorMessage: "There are no approval logs at the moment.",
        approvalLogErrorMessageTitle: "Error",
        approval_logs_main_section: false,
      });
    } else if (
      reportsData.data.status === 200 &&
      reportsData.data.message === "success"
    ) {
      this.setState({
        approvalLogs: reportsData.data.data,
        approvalLogErrorMessageTitle: "",
        approvalLogErrorMessage: "",
        approval_logs_main_section: false,
      });
    } else {
      // console.log("Last: ", reportsData.data);
      this.setState({
        approvalLogErrorMessage:
          "There is some error while getting the approval logs.",
        approvalLogErrorMessageTitle: "System Error",
        approval_logs_main_section: false,
      });
    }
  };

  handleAccordionToggle(id, index) {
    const element = document.getElementById(id);
    const isActive = this.state.activeAccordion === index;

    // Close all accordions first
    const allAccordionItems = document.querySelectorAll(".accordion-row");
    allAccordionItems.forEach((item) => {
      item.classList.remove("show");
    });

    // Toggle the clicked accordion
    if (!isActive) {
      element.classList.add("show");
      this.setState({ activeAccordion: index });
    } else {
      this.setState({ activeAccordion: null });
    }
  }

  handleLoadMore = () => {
    this.setState((prevState) => ({
      visibleCount: prevState.visibleCount + 5,
    }));
  };

  modalHideMarketingPDF = (id) => {
    window.$("#" + id).modal("hide");
  };

  handleDateChange = (newDate) => {
    const { issueDate } = this.state;

    if (issueDate && newDate < new Date(issueDate)) {
      this.setState({
        errorMessageInfo: "Due date cannot be earlier than Issue date.",
      });
    } else {
      this.setState({
        dueDate: newDate,
        errorMessageInfo: "", // clear error if valid
      });
    }
  };

  getSubpoenaResult = async () => {
    window.$("#subpoenaResult").modal("show");
  };

  render() {
    //  let tableTitle = this.props.props.match.params.api_url.replaceAll("_", " ");
    const Theme = {
      palette: {
        primary: {
          contrastText: "#FFFFFF",
          dark: "#000000",
          main: "#000000",
          light: "#000000",
        },
      },
    };
    const {
      isOpen,
      value,
      start_date,
      end_date,
      tags,
      inputValue,
      description,
      maxChars,
      inputValueCc,
      useGooglePlaces,
      inputValueCcApproval,
      allComments,
      visibleCount,
    } = this.state;
    const visibleItems = allComments.slice(0, visibleCount);
    const formattedDateRange = start_date ? `${start_date} - ${end_date}` : "";
    const options = {
      selectableRows: "multiple", // Enable checkboxes for row selection
    };
    const remaining = maxChars - description.length;
    const styles = {
      container: {
        width: "100%",
        maxWidth: "100%",
      },
      inputWrapper: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        border: "1px solid #ccc",
        padding: "5px",
        borderRadius: "5px",
        minHeight: "40px",
      },
      tag: {
        display: "flex",
        alignItems: "center",
        backgroundColor: "#ebeef2",
        color: "#526484",
        padding: "0 .5rem",
        borderRadius: "3px",
        margin: "0.1875rem 0.1875rem",
        fontSize: "13px",
        lineHeight: "1.5rem",
        fontWeight: "bold",
      },
      removeButton: {
        marginLeft: "8px",
        border: "none",
        background: "none",
        color: "#526484",
        fontWeight: "bold",
        cursor: "pointer",
      },
      input: {
        border: "none",
        outline: "none",
        padding: "5px",
        fontSize: "14px",
        flexGrow: 1,
        minWidth: "50px",
      },
    };
    return (
      <>
        <div className="nk-content " id="Support_Block">
          <div className="container-fluid">
            <div className="nk-content-inner">
              <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                  <div className="nk-block-between g-3">
                    <div className="nk-block-head-content">
                      <h3 className="nk-block-title page-title">
                        Requests /{" "}
                        <strong className="text-primary small">
                          {this.state.title}
                        </strong>
                      </h3>
                      <div className="nk-block-des text-soft">
                        <ul className="list-inline">
                          <li>
                            Reference #:{" "}
                            <span className="text-base">
                              {this.state.subpoena_ren_no}
                            </span>
                          </li>
                          {/*<li>Last Login: <span className="text-base">15 Feb, 2019 01:02 PM</span></li>*/}
                        </ul>
                      </div>
                    </div>
                    <div className="nk-block-head-content">
                      <a
                        onClick={() => this.addMenuHistory("/Compliance")}
                        style={{ cursor: "pointer" }}
                        className="btn btn-outline-light bg-white d-none d-sm-inline-flex"
                      >
                        <em className="icon ni ni-arrow-left"></em>
                        <span>Back</span>
                      </a>
                      <a
                        onClick={() => this.addMenuHistory("/Compliance")}
                        style={{ cursor: "pointer" }}
                        className="btn btn-icon btn-outline-light bg-white d-inline-flex d-sm-none"
                      >
                        <em className="icon ni ni-arrow-left"></em>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="nk-block">
                  <div className="card card-bordered">
                    <div className="card-aside-wrap">
                      <div className="card-content">
                        <ul className="nav nav-tabs nav-tabs-mb-icon nav-tabs-card">
                          <li
                            className="nav-item viewClients_nav-item_customStyle"
                            style={{ cursor: "pointer" }}
                          >
                            <a
                              className={`nav-link ${
                                this.state.activeTab === "requester_info"
                                  ? "active"
                                  : ""
                              }`}
                              onClick={(e) => {
                                this.changeActiveTab("requester_info");
                                //this.clientAgreements();
                              }}
                              style={{ fontSize: "0.82rem" }}
                            >
                              <em className="icon ni ni-user-circle"></em>
                              <span>Requester Information</span>
                            </a>
                          </li>
                          <li
                            className="nav-item viewClients_nav-item_customStyle"
                            style={{ cursor: "pointer" }}
                          >
                            <a
                              className={`nav-link ${
                                this.state.activeTab === "request_info"
                                  ? "active"
                                  : ""
                              }`}
                              onClick={(e) => {
                                this.changeActiveTab("request_info");
                                //this.clientAgreements();
                              }}
                              style={{ fontSize: "0.82rem" }}
                            >
                              <em className="icon ni ni-repeat"></em>
                              <span>Request Information & Actions</span>
                            </a>
                          </li>
                          <li
                            className="nav-item viewClients_nav-item_customStyle"
                            style={{ cursor: "pointer" }}
                          >
                            <a
                              className={`nav-link ${
                                this.state.activeTab === "records_sought"
                                  ? "active"
                                  : ""
                              }`}
                              onClick={(e) => {
                                this.changeActiveTab("records_sought");
                                //this.clientAgreements();
                              }}
                              style={{ fontSize: "0.82rem" }}
                            >
                              <em className="icon ni ni-file-text"></em>
                              <span>DID(s) & Records Sought</span>
                            </a>
                          </li>
                          <li
                            className="nav-item viewClients_nav-item_customStyle"
                            style={{ cursor: "pointer" }}
                          >
                            <a
                              className={`nav-link ${
                                this.state.activeTab === "comments_emails"
                                  ? "active"
                                  : ""
                              }`}
                              onClick={(e) => {
                                this.changeActiveTab("comments_emails");
                                //this.clientAgreements();
                              }}
                              style={{ fontSize: "0.82rem" }}
                            >
                              <em className="icon ni ni-question"></em>
                              <span>Comments / Emails</span>
                            </a>
                          </li>
                          <li
                            className="nav-item viewClients_nav-item_customStyle"
                            style={{ cursor: "pointer" }}
                          >
                            <a
                              className={`nav-link ${
                                this.state.activeTab === "documents"
                                  ? "active"
                                  : ""
                              }`}
                              onClick={(e) => {
                                this.changeActiveTab("documents");
                                //this.clientAgreements();
                              }}
                              style={{ fontSize: "0.82rem" }}
                            >
                              <em className="icon ni ni-files"></em>
                              <span>Result Documents</span>
                            </a>
                          </li>
                        </ul>
                        <div className="tab-content">
                          <div
                            className={
                              this.state.activeTab === "requester_info"
                                ? "tab-pane active"
                                : "tab-pane"
                            }
                            id="tabItemProducts"
                          >
                            <div className="card-inner">
                              <div className="nk-block">
                                <p>
                                  Update the information about the requestor.
                                </p>
                                <div className="row gy-4">
                                  {this.state.errorMessageRequester !== "" ? (
                                    <div className="col-sm-12">
                                      <div
                                        className="example-alert example-alert-revoke mt-3 mb-3"
                                        style={{ marginBottom: "15px" }}
                                      >
                                        <div className="alert alert-pro alert-danger">
                                          <div className="alert-text">
                                            <h4>
                                              {
                                                this.state
                                                  .errorMessageRequesterTitle
                                              }
                                            </h4>
                                            <p>
                                              {this.state.errorMessageRequester}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                  {this.state.successMessageRequester !== "" ? (
                                    <div className="col-sm-12">
                                      <div
                                        className="example-alert example-alert-revoke mt-3 mb-3"
                                        style={{ marginBottom: "15px" }}
                                      >
                                        <div className="alert alert-pro alert-success">
                                          <div className="alert-text">
                                            <h4>Success</h4>
                                            <p>
                                              {
                                                this.state
                                                  .successMessageRequester
                                              }
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                  <div className="col-sm-4">
                                    <div className="form-group">
                                      <label
                                        className="form-label"
                                        for="requester_name"
                                      >
                                        Requester Name / Agency <sup>*</sup>
                                      </label>
                                      <div className="form-control-wrap">
                                        <input
                                          type="text"
                                          className="form-control"
                                          id="requester_name"
                                          name="requester_name"
                                          value={this.state.requester_name}
                                          onChange={this.handleChanges}
                                          maxLength={100}
                                          placeholder="e.g., Christian County Prosecuting Attorney’s Office / Federal Bureau of Investigation"
                                        autoComplete="new-password" />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-sm-4">
                                    <div className="form-group">
                                      <label
                                        className="form-label"
                                        for="requester_type"
                                      >
                                        Requester Type
                                      </label>
                                      <div className="form-control-wrap ">
                                        <div className="form-control-select">
                                          <select
                                            className="form-control"
                                            id="requester_type"
                                            name="requester_type"
                                            value={this.state.requester_type}
                                            onChange={this.handleChanges}
                                          >
                                            <option
                                              value="Federal Agency"
                                              key="rt-1"
                                            >
                                              Federal Agency
                                            </option>
                                            <option
                                              value="State Agency"
                                              key="rt-2"
                                            >
                                              State Agency
                                            </option>
                                            <option
                                              value="Local Agency"
                                              key="rt-3"
                                            >
                                              Local Agency
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-sm-4">
                                    <div className="form-group">
                                      <label
                                        className="form-label"
                                        for="office_devision"
                                      >
                                        Office / Division <sup>*</sup>
                                      </label>
                                      <div className="form-control-wrap">
                                        <input
                                          type="text"
                                          className="form-control"
                                          id="office_devision"
                                          name="office_devision"
                                          value={this.state.office_devision}
                                          onChange={this.handleChanges}
                                          maxLength={64}
                                          placeholder="e.g., Criminal Division, Cybercrime Unit"
                                        autoComplete="new-password" />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-12">
                                    <p style={{ fontWeight: "bold" }}>
                                      Requester Contact Person(s)
                                    </p>
                                  </div>
                                  <div className="col-sm-6">
                                    <div className="form-group">
                                      <label
                                        className="form-label"
                                        for="requester_contact_name"
                                      >
                                        Contact Person name <sup>*</sup>
                                      </label>
                                      <div className="form-control-wrap">
                                        <input
                                          type="text"
                                          className="form-control"
                                          id="requester_contact_name"
                                          name="requester_contact_name"
                                          value={
                                            this.state.requester_contact_name
                                          }
                                          onChange={this.handleChanges}
                                          maxLength={64}
                                          placeholder="e.g., John Doe / Kevin Kostner"
                                        autoComplete="new-password" />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-sm-6">
                                    <div className="form-group">
                                      <label
                                        className="form-label"
                                        for="requester_contact_title"
                                      >
                                        Contact Person Title
                                      </label>
                                      <div className="form-control-wrap">
                                        <input
                                          type="text"
                                          className="form-control"
                                          id="requester_contact_title"
                                          name="requester_contact_title"
                                          value={
                                            this.state.requester_contact_title
                                          }
                                          onChange={this.handleChanges}
                                          maxLength={64}
                                          placeholder="e.g., Special Agent / Assistant Prosecuting Attorney"
                                        autoComplete="new-password" />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-sm-6">
                                    <div className="form-group">
                                      <label
                                        className="form-label"
                                        for="requester_address"
                                      >
                                        Address <sup>*</sup>
                                      </label>
                                      <div className="form-control-wrap">
                                        {this.state.address_autocomplete ===
                                        "Yes" ? (
                                          useGooglePlaces ? (
                                            <GooglePlacesAutocomplete
                                              apiKey={
                                                process.env
                                                  .REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY
                                              }
                                              apiOptions={{ loading: 'async' }}
                                              selectProps={{
                                                value: this.state
                                                  .requester_address
                                                  ? {
                                                      label:
                                                        this.state
                                                          .requester_address,
                                                      value:
                                                        this.state
                                                          .requester_address,
                                                    }
                                                  : null,
                                                onChange:
                                                  this.handleAddressSelect,
                                                placeholder: this.state
                                                  .requester_address
                                                  ? null
                                                  : "Enter your address..",
                                                styles: {
                                                  control: (provided) => ({
                                                    ...provided,
                                                    minHeight: "40px",
                                                  }),
                                                },
                                              }}
                                              className="googleLocation-autocomplete"
                                            />
                                          ) : (
                                            <input
                                              type="text"
                                              className="form-control "
                                              id="requester_address"
                                              name="requester_address"
                                              value={
                                                this.state.requester_address
                                              }
                                              onChange={this.handleChanges}
                                              placeholder="Enter your address"
                                              //maxLength={50}
                                              inputProps={{
                                                maxLength: 50,
                                              }}
                                              fullWidth
                                              error={
                                                this.state
                                                  .errorClientAddress ===
                                                "error"
                                              }
                                            autoComplete="new-password" />
                                          )
                                        ) : (
                                          // address_autocomplete === "No" → show PO Box only
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="requester_address"
                                            name="requester_address"
                                            value={this.state.requester_address}
                                            onChange={this.handleChanges}
                                            placeholder="Enter your address"
                                            //maxLength={50}
                                            inputProps={{
                                              maxLength: 50,
                                            }}
                                            fullWidth
                                            error={
                                              this.state.errorClientAddress ===
                                              "error"
                                            }
                                          autoComplete="new-password" />
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-sm-6">
                                    <div className="form-group">
                                      <label
                                        className="form-label"
                                        for="requester_phone"
                                      >
                                        Phone <sup>*</sup>
                                      </label>
                                      <div className="form-control-wrap">
                                        <PhoneInput
                                          required
                                          defaultCountry={"us"}
                                          inputProps={{
                                            name: "requester_phone",
                                            id: "requester_phone",
                                            maxLength: 20,
                                          }}
                                          style={{
                                            marginTop: "0px",
                                            height: "40px",
                                          }}
                                          value={
                                            this.state.isLoading
                                              ? ""
                                              : this.state.requester_phone
                                          }
                                          placeholder={
                                            this.state.isLoading
                                              ? "Loading..."
                                              : "Enter the requester phone number"
                                          }
                                          onChange={(value) =>
                                            this.handleChangePhone({
                                              target: {
                                                name: "requester_phone",
                                                value,
                                              },
                                            })
                                          }
                                          helperText="Enter the requester phone number."
                                          label="Requester Phone Number"
                                          ref={this.phoneInputRef}
                                          onFocus={this.handleFocus}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-sm-6">
                                    <div className="form-group">
                                      <label
                                        className="form-label"
                                        for="requester_email"
                                      >
                                        Email <sup>*</sup>
                                      </label>
                                      <div className="form-control-wrap">
                                        <input
                                          type="text"
                                          className="form-control"
                                          id="requester_email"
                                          name="requester_email"
                                          value={this.state.requester_email}
                                          onChange={this.handleChanges}
                                          maxLength={100}
                                          placeholder="Enter the valid email address"
                                        autoComplete="new-password" />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-sm-6">
                                    <div className="form-group">
                                      <label
                                        className="form-label"
                                        for="legal_authority_cited"
                                      >
                                        Legal Authority Cited{" "}
                                        <Tooltip title="Agency" placement="top">
                                          <span className="text-primary">
                                            <em className="icon ni ni-info"></em>
                                          </span>
                                        </Tooltip>
                                      </label>
                                      <div className="form-control-wrap ">
                                        <div className="form-control-select">
                                          <select
                                            className="form-control"
                                            id="legal_authority_cited"
                                            name="legal_authority_cited"
                                            value={
                                              this.state.legal_authority_cited
                                            }
                                            onChange={this.handleChanges}
                                          >
                                            <option value="Federal" key="lac-1">
                                              Federal
                                            </option>
                                            <option value="State" key="lac-2">
                                              State
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-sm-6">
                                    <div className="form-group">
                                      <label
                                        className="form-label"
                                        for="request_type"
                                      >
                                        Type of Request
                                      </label>
                                      <div className="form-control-wrap ">
                                        <div className="form-control-select">
                                          <select
                                            className="form-control"
                                            id="request_type"
                                            name="request_type"
                                            value={this.state.request_type}
                                            onChange={this.handleChanges}
                                          >
                                            <option
                                              value="Subpoena"
                                              key="ret-1"
                                            >
                                              Subpoena
                                            </option>
                                            <option
                                              value="Court Order"
                                              key="ret-2"
                                            >
                                              Court Order
                                            </option>
                                            <option
                                              value="Search Warrant"
                                              key="ret-3"
                                            >
                                              Search Warrant
                                            </option>
                                            <option
                                              value="Preservation Request"
                                              key="ret-4"
                                            >
                                              Preservation Request
                                            </option>
                                            <option value="Other" key="ret-5">
                                              Other (Specify)
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {this.state.request_type === "Other" ? (
                                    <div className="col-sm-6">
                                      <div className="form-group">
                                        <label
                                          className="form-label"
                                          for="requester_email"
                                        >
                                          Specify Other Type <sup>*</sup>
                                        </label>
                                        <div className="form-control-wrap">
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="request_type_other"
                                            name="request_type_other"
                                            value={
                                              this.state.request_type_other
                                            }
                                            onChange={this.handleChanges}
                                            maxLength={100}
                                            placeholder=""
                                          autoComplete="new-password" />
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                  <div className="col-sm-6">
                                    <div
                                      className="custom-control custom-control-lg custom-checkbox"
                                      style={{
                                        padding: 0,
                                        marginLeft: "3rem",
                                        marginTop: "10px",
                                      }}
                                    >
                                      <div className="form-group mt-4">
                                        <input
                                          type="checkbox"
                                          className="custom-control-input"
                                          id="customCheckRequester"
                                          onChange={() => {
                                            const isChecked =
                                              !this.state.notifyRequester;
                                            this.setState({
                                              notifyRequester: isChecked,
                                            });
                                            // console.log("Notify Checkbox Checked:", isChecked);
                                          }}
                                        />
                                        <label
                                          className="custom-control-label"
                                          for="customCheckRequester"
                                        >
                                          Send notification to the admin
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="nk-divider divider md"></div>
                              <div className="nk-kycfm-action pt-2 text-right">
                                {this.state.requester_info_button === true ? (
                                  <button
                                    className="btn btn-lg btn-primary"
                                    type="button"
                                    disabled
                                  >
                                    <span
                                      className="spinner-grow spinner-grow-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    <span> Processing... </span>
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    className="btn btn-lg btn-primary"
                                    onClick={() => this.updateRequesterInfo()}
                                    disabled={this.state.disabled}
                                  >
                                    <em className="icon ni ni-save"></em> &nbsp;
                                    Save Requester Info
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                          <div
                            className={
                              this.state.activeTab === "request_info"
                                ? "tab-pane active"
                                : "tab-pane"
                            }
                            id="tabItemProducts2"
                          >
                            <div className="card-inner">
                              <div className="nk-block">
                                <p>
                                  Update the request information like title,
                                  Case Reference / Docket # and date range for
                                  which the record is being sought.
                                </p>
                                <div className="row g-4">
                                  {this.state.errorMessageRequest !== "" ? (
                                    <div className="col-sm-12">
                                      <div
                                        className="example-alert example-alert-revoke mt-3 mb-3"
                                        style={{ marginBottom: "15px" }}
                                      >
                                        <div className="alert alert-pro alert-danger">
                                          <div className="alert-text">
                                            <h4>
                                              {
                                                this.state
                                                  .errorMessageRequestTitle
                                              }
                                            </h4>
                                            <p>
                                              {this.state.errorMessageRequest}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                  {this.state.successMessageRequest !== "" ? (
                                    <div className="col-sm-12">
                                      <div
                                        className="example-alert example-alert-revoke mt-3 mb-3"
                                        style={{ marginBottom: "15px" }}
                                      >
                                        <div className="alert alert-pro alert-success">
                                          <div className="alert-text">
                                            <h4>Success</h4>
                                            <p>
                                              {this.state.successMessageRequest}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                  <div className="col-lg-6">
                                    <div className="form-group">
                                      <label className="form-label" for="title">
                                        Title <sup>*</sup>
                                      </label>
                                      <div className="form-control-wrap">
                                        <input
                                          type="text"
                                          className="form-control form-control-lg"
                                          id="title_edit"
                                          name="title_edit"
                                          value={this.state.title_edit}
                                          onChange={this.handleChanges}
                                          placeholder=""
                                          maxLength="100"
                                        autoComplete="new-password" />
                                        <small>
                                          Enter descriptive title for your
                                          report request.
                                        </small>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="form-group">
                                      <label
                                        className="form-label"
                                        for="subpoena_ren_no"
                                      >
                                        Reference # <sup>*</sup>
                                      </label>
                                      <div className="form-control-wrap">
                                        <input
                                          type="text"
                                          className="form-control form-control-lg"
                                          id="subpoena_ren_no_edit"
                                          name="subpoena_ren_no_edit"
                                          value={
                                            this.state.subpoena_ren_no_edit
                                          }
                                          onChange={this.handleChangeRef}
                                          placeholder=""
                                          maxLength={25}
                                        autoComplete="new-password" />
                                        <small>
                                          Enter descriptive ref. number for your
                                          subpoena request. Only numbers,
                                          alphabets, - and _ is allowed. Maximum
                                          25 characters are allowed.
                                        </small>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="form-group">
                                      <div onClick={this.onToggle} className="">
                                        <TextField
                                          label="Date and Time"
                                          variant="outlined"
                                          fullWidth
                                          value={formattedDateRange}
                                          InputProps={{
                                            onClick: this.onToggle,
                                          }}
                                          placeholder="Select Date Range"
                                        autoComplete="new-password"
                                        />
                                      </div>
                                    </div>
                                    {isOpen && (
                                      <div
                                        className="fixed inset-0"
                                        style={{
                                          zIndex: 1000,
                                          position: "absolute",
                                          marginTop: "-20px",
                                        }}
                                      >
                                        <div
                                          className="absolute inset-0"
                                          onClick={this.onToggle}
                                        ></div>
                                        <div
                                          className="absolute top-40 left-1/2 -translate-x-1/2 bg-white shadow-lg rounded-lg p-4"
                                          style={{ zIndex: 1001 }}
                                        >
                                          <div
                                            style={{
                                              position: "absolute",
                                              top: "10px",
                                              right: "10px",
                                              cursor: "pointer",
                                              zIndex: 1002,
                                            }}
                                            onClick={this.onToggle}
                                          >
                                            <em className="icon ni ni-cross"></em>
                                          </div>
                                          <DateRangePicker
                                            value={value}
                                            onSelect={this.onSelect}
                                            singleDateRange={true}
                                            numberOfCalendars={2}
                                            showLegend={true}
                                          />
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-xxl-6 col-md-6 col-sm-12">
                                    <div className="form-group">
                                      <label className="form-label" for="dueDate">
                                        Due Date
                                      </label>
                                      <div className="form-control-wrap">
                                        <MuiPickersUtilsProvider
                                          utils={DateFnsUtils}
                                        >
                                          <DatePicker
                                            variant="dialog"
                                            name="dueDate"
                                            id="dueDate"
                                            inputVariant="outlined"
                                            format="MM-dd-yyyy"
                                            fullWidth
                                            value={this.state.dueDate}
                                            onChange={this.handleDateChange}
                                            rientation="landscape"
                                            InputProps={{
                                              style: {
                                                padding: "1px 1px", // adjust as you like
                                              },
                                            }}
                                            size="small"
                                          />
                                        </MuiPickersUtilsProvider>
                                      </div>
                                      <div className="form-note">
                                        Due date of the request
                                      </div>
                                    </div>
                                  </div>
                                  {auth.getSubpoenaType() !== "Yes" ? (
                                    <>
                                      <div className="col-lg-6">
                                        <div className="form-group">
                                          <label
                                            className="form-label"
                                            for="report_url_id"
                                          >
                                            Report ID
                                          </label>
                                          <div className="form-control-wrap">
                                            <input
                                              type="text"
                                              className="form-control form-control-lg"
                                              id="report_url_id"
                                              name="report_url_id"
                                              value={this.state.report_url_id}
                                              onChange={this.handleChanges}
                                              placeholder=""
                                            autoComplete="new-password" />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="form-group">
                                          <label
                                            className="form-label"
                                            for="report_params"
                                          >
                                            Params
                                          </label>
                                          <div className="form-control-wrap">
                                            <input
                                              type="text"
                                              className="form-control form-control-lg"
                                              id="report_params"
                                              name="report_params"
                                              value={this.state.report_params}
                                              onChange={this.handleChanges}
                                              placeholder=""
                                            autoComplete="new-password" />
                                            <small>
                                              <sup>*</sup>Sample Params string
                                              should be like this and this
                                              should be locked in Metabase
                                              interface
                                              <br />
                                              {`{ "COLUMN_NAME_1": VALUE, "COLUMN_NAME_2": VALUE }`}
                                            </small>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  ) : null}
                                  <div className="col-lg-6">
                                    <div className="form-group">
                                      <label
                                        className="form-label"
                                        for="publish_report"
                                      >
                                        Publish Report
                                      </label>
                                      <div className="form-control-wrap ">
                                        <div className="form-control-select">
                                          <select
                                            className="form-control form-control-lg"
                                            name="publish_report"
                                            id="publish_report"
                                            value={this.state.publish_report}
                                            onChange={this.handleChanges}
                                          >
                                            <option key="0" value="No">
                                              No
                                            </option>
                                            <option key="1" value="Yes">
                                              Yes
                                            </option>
                                          </select>
                                        </div>
                                        <small>
                                          The report will be displayed only if
                                          it is published.
                                        </small>
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    className="col-lg-12"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <h6
                                      style={{
                                        margin: 0,
                                        marginRight: "10px",
                                      }}
                                    >
                                      Extra Jump Parameters <sup></sup>
                                    </h6>
                                  </div>
                                  <div className="col-lg-12">
                                    <div className="form-group">
                                      <table
                                        className="table table-bordered"
                                        id="tab_logic"
                                      >
                                        <thead className="thead-light">
                                          <tr>
                                            <th
                                              className="text-left"
                                              style={{
                                                lineHeight: "28px",
                                              }}
                                            >
                                              {" "}
                                              Parameter Title{" "}
                                            </th>
                                            <th
                                              className="text-left"
                                              style={{
                                                lineHeight: "28px",
                                              }}
                                            >
                                              {" "}
                                              Parameters{" "}
                                              <small>
                                                <sup>*</sup>i.e
                                                ?dash_id=123&date_filter=2025-06-16&company_name=ABC%20Company)
                                              </small>
                                            </th>

                                            <th className="text-center">
                                              &nbsp;
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td
                                              style={{
                                                paddingTop: "20px",
                                              }}
                                            >
                                              <input
                                                type="text"
                                                className="form-control form-control-lg"
                                                id="extra_params_title"
                                                name="extra_params_title"
                                                value={
                                                  this.state.extra_params_title
                                                }
                                                onChange={this.handleChanges}
                                                maxLength={64}
                                                placeholder=""
                                              autoComplete="new-password" />
                                            </td>

                                            <td
                                              style={{
                                                paddingTop: "20px",
                                                width: "60%",
                                              }}
                                            >
                                              <input
                                                type="text"
                                                className="form-control form-control-lg"
                                                id="extra_params"
                                                name="extra_params"
                                                value={this.state.extra_params}
                                                onChange={this.handleChangesEnc}
                                                placeholder=""
                                              autoComplete="new-password" />
                                              <div className="nk-block-between-md">
                                                <div className="nk-block-head-content">
                                                  <label
                                                    for="extra_params"
                                                    style={{
                                                      color: "#344357",
                                                      fontWeight: "500",
                                                      marginBottom: "8px",
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </label>
                                                </div>
                                                <div className="nk-block-head-content">
                                                  <ul className="nk-block-tools gx-3">
                                                    <li>
                                                      {this.state
                                                        .is_encrypted ===
                                                      "Yes" ? (
                                                        <a
                                                          className="text-primary fs-11"
                                                          onClick={() =>
                                                            this.decrypt_parameters()
                                                          }
                                                          style={{
                                                            cursor: "pointer",
                                                            fontWeight: "500",
                                                          }}
                                                        >
                                                          Decrypt
                                                        </a>
                                                      ) : null}
                                                    </li>
                                                  </ul>
                                                </div>
                                              </div>
                                            </td>
                                            <td
                                              className="text-center"
                                              style={{
                                                paddingTop: "20px",
                                              }}
                                            >
                                              {this.state.is_encrypted ===
                                              "No" ? (
                                                <button
                                                  type="button"
                                                  className="btn btn-warning"
                                                  onClick={() =>
                                                    this.encrypt_parameters()
                                                  }
                                                >
                                                  <em className="icon ni ni-security"></em>{" "}
                                                  <span>Encrypt</span>
                                                </button>
                                              ) : this.state.is_encrypted ===
                                                "Yes" ? (
                                                <button
                                                  type="button"
                                                  className="btn btn-primary"
                                                  onClick={() =>
                                                    this.addParams()
                                                  }
                                                >
                                                  <em className="icon ni ni-plus-round"></em>{" "}
                                                  <span>Add</span>
                                                </button>
                                              ) : null}
                                            </td>
                                          </tr>
                                          {this.state.jumpError &&
                                          this.state.jumpError !== "" ? (
                                            <tr>
                                              <td colSpan={3}>
                                                <span className="text-danger">
                                                  {this.state.jumpError}
                                                </span>
                                              </td>
                                            </tr>
                                          ) : null}
                                          {this.state.extra_params_array &&
                                          this.state.extra_params_array.length >
                                            0 ? (
                                            <>
                                              {this.state.extra_params_array
                                                .filter(
                                                  (item) =>
                                                    item.title ||
                                                    item.parameter,
                                                )
                                                .map((item, idx) => (
                                                  <tr key={`id-${idx}`}>
                                                    <td>{item.title}</td>
                                                    <td className="text-primary">
                                                      <small>{`${APP_URL}viewAdminAnalytics/${item.parameter}`}</small>
                                                    </td>
                                                    <td className="text-center">
                                                      <CopyToClipboard
                                                        text={`${APP_URL}viewAdminAnalytics/${item.parameter}`}
                                                        onCopy={() =>
                                                          this.setState({
                                                            copied: idx,
                                                          })
                                                        }
                                                      >
                                                        <button
                                                          className="btn btn-success btn-sm"
                                                          type="button"
                                                        >
                                                          <em className="icon ni ni-copy"></em>{" "}
                                                          Copy{" "}
                                                          {this.state.copied ===
                                                          idx ? (
                                                            <span
                                                              style={{
                                                                color: "white",
                                                                marginLeft:
                                                                  "10px",
                                                              }}
                                                            >
                                                              <em className="icon ni ni-done"></em>
                                                            </span>
                                                          ) : null}
                                                        </button>
                                                      </CopyToClipboard>
                                                      <a
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={this.handleRemoveSpecificRow(
                                                          idx,
                                                        )}
                                                      >
                                                        <span
                                                          className="badge badge-outline-danger"
                                                          style={{
                                                            cursor: "pointer",
                                                            paddingTop: "3px",
                                                            paddingBottom:
                                                              "3px",
                                                            paddingLeft: "7px",
                                                            fontSize: "18px",
                                                            marginLeft: "5px",
                                                          }}
                                                        >
                                                          <em className="icon ni ni-trash"></em>
                                                        </span>
                                                      </a>
                                                    </td>
                                                  </tr>
                                                ))}
                                            </>
                                          ) : null}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                  <div
                                    className="col-lg-12"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <h6
                                      style={{
                                        margin: 0,
                                        marginRight: "10px",
                                      }}
                                    >
                                      Description <sup>*</sup>
                                    </h6>
                                  </div>

                                  <div className="col-lg-12">
                                    <div className="form-group">
                                      <div className="form-control-group">
                                        <TextareaAutosize
                                          maxrows={10}
                                          name="description"
                                          id="description"
                                          aria-label=""
                                          placeholder=""
                                          //maxLength={500}
                                          value={this.state.description}
                                          helperText="Maximum 1000 characters"
                                          onChange={this.handleChangeTextarea}
                                          style={{
                                            width: "100%",
                                            minHeight: "150px",
                                            borderColor: "rgba(0, 0, 0, 0.125)",
                                            borderRadius: "4px",
                                            padding: "5px",
                                          }}
                                          variant="outlined"
                                        />
                                        <div className="form-note">
                                          {remaining} characters remaining
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-sm-12">
                                    <div
                                      className="custom-control custom-control-lg custom-checkbox"
                                      style={{
                                        padding: 0,
                                        marginLeft: "3rem",
                                      }}
                                    >
                                      <div className="form-group mt-4">
                                        <input
                                          type="checkbox"
                                          className="custom-control-input"
                                          id="customCheckRequest"
                                          onChange={() => {
                                            const isChecked =
                                              !this.state.notifyRequest;
                                            this.setState({
                                              notifyRequest: isChecked,
                                            });
                                            // console.log("Notify Checkbox Checked:", isChecked);
                                          }}
                                        />
                                        <label
                                          className="custom-control-label"
                                          for="customCheckRequest"
                                        >
                                          Send notification to the admin
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="nk-divider divider md"></div>
                                <div className="nk-kycfm-action pt-2 text-right">
                                  {this.state.request_info_button === true ? (
                                    <button
                                      className="btn btn-lg btn-primary"
                                      type="button"
                                      disabled
                                    >
                                      <span
                                        className="spinner-grow spinner-grow-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                      <span> Processing... </span>
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      className="btn btn-lg btn-primary"
                                      onClick={() => this.updateRequestInfo()}
                                      disabled={this.state.disabled}
                                    >
                                      <em className="icon ni ni-save"></em>{" "}
                                      &nbsp; Save Request Info & Actions
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            className={
                              this.state.activeTab === "records_sought"
                                ? "tab-pane active"
                                : "tab-pane"
                            }
                            id="tabItemProducts3"
                          >
                            <div className="card-inner">
                              <div className="nk-block">
                                <p>
                                  Enter DID(s) or upload DID(s) file. Please
                                  select the records sought from the options
                                  below. If the required option is not
                                  available, you may add a new one by clicking
                                  Add New Option and then the Plus button. And
                                  brief description of why the appearance,
                                  testimony, or records are being sought.
                                </p>
                                <div className="row g-4">
                                  {this.state.errorMessageSought !== "" ? (
                                    <div className="col-sm-12">
                                      <div
                                        className="example-alert example-alert-revoke mt-3 mb-3"
                                        style={{ marginBottom: "15px" }}
                                      >
                                        <div className="alert alert-pro alert-danger">
                                          <div className="alert-text">
                                            <h4>
                                              {
                                                this.state
                                                  .errorMessageSoughtTitle
                                              }
                                            </h4>
                                            <p>
                                              {this.state.errorMessageSought}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                  {this.state.successMessageSought !== "" ? (
                                    <div className="col-sm-12">
                                      <div
                                        className="example-alert example-alert-revoke mt-3 mb-3"
                                        style={{ marginBottom: "15px" }}
                                      >
                                        <div className="alert alert-pro alert-success">
                                          <div className="alert-text">
                                            <h4>Success</h4>
                                            <p>
                                              {this.state.successMessageSought}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                  <div
                                    className="col-lg-12"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <h6
                                      style={{
                                        margin: 0,
                                        marginRight: "10px",
                                      }}
                                    >
                                      DID(s) <sup></sup>
                                    </h6>
                                  </div>

                                  <div className="col-lg-12">
                                    <div className="form-group">
                                      <ul className="nk-kycfm-control-list g-3">
                                        <li className="nk-kycfm-control-item">
                                          <input
                                            className="nk-kycfm-control"
                                            type="radio" // Use checkbox instead of radio for a toggle switch
                                            name="enableDids"
                                            id="enableDids1"
                                            data-title="Enter DIDs"
                                            checked={
                                              this.state.enableDids === "dids"
                                                ? true
                                                : false
                                            }
                                            onChange={this.handleOptionChange}
                                            value="dids"
                                          autoComplete="new-password" />
                                          <label
                                            className="nk-kycfm-label"
                                            htmlFor="enableDids1"
                                          >
                                            <span className="nk-kycfm-label-icon">
                                              <div className="label-icon fs-22px">
                                                <em className="icon ni ni-dashboard"></em>
                                              </div>
                                            </span>
                                            <span className="nk-kycfm-label-text">
                                              Enter DID's
                                            </span>
                                          </label>
                                        </li>
                                        <li className="nk-kycfm-control-item">
                                          <input
                                            className="nk-kycfm-control"
                                            type="radio" // Use checkbox instead of radio for a toggle switch
                                            name="enableDids"
                                            id="enableDids2"
                                            data-title="Allow Mutiple Submission"
                                            checked={
                                              this.state.enableDids === "csv"
                                                ? true
                                                : false
                                            }
                                            onChange={this.handleOptionChange}
                                            value="csv"
                                          autoComplete="new-password" />
                                          <label
                                            className="nk-kycfm-label"
                                            htmlFor="enableDids2"
                                          >
                                            <span className="nk-kycfm-label-icon">
                                              <div className="label-icon fs-22px">
                                                <em className="icon ni ni-repeat-v"></em>
                                              </div>
                                            </span>
                                            <span className="nk-kycfm-label-text">
                                              Upload CSV File
                                            </span>
                                          </label>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>

                                  {this.state.enableDids === "dids" ? (
                                    <div className="col-lg-12">
                                      <div className="form-group">
                                        <label className="form-label" for="title">
                                          DID(s) <sup></sup>
                                        </label>
                                        <div className="form-control-wrap">
                                          <div style={styles.container}>
                                            <div style={styles.inputWrapper}>
                                              {tags.map((tag, index) => (
                                                <span
                                                  key={index}
                                                  style={styles.tag}
                                                >
                                                  {tag}
                                                  <button
                                                    type="button"
                                                    style={styles.removeButton}
                                                    onClick={() =>
                                                      this.handleRemoveTag(
                                                        index,
                                                      )
                                                    }
                                                  >
                                                    &times;
                                                  </button>
                                                </span>
                                              ))}
                                              <input
                                                type="text"
                                                value={inputValue}
                                                onChange={this.handleChangeTag}
                                                onKeyDown={this.handleKeyDown}
                                                onPaste={this.handlePaste}
                                                placeholder="Enter or paste 10-digit numbers..."
                                                style={styles.input}
                                              autoComplete="new-password" />
                                            </div>
                                          </div>
                                          <small>
                                            1. Only numbers allowed.
                                            <br />
                                            2. Maximum 100 numbers allowed.
                                            <br />
                                            3. Only 10-digit numbers are
                                            accepted.
                                            <br />
                                            4. No duplicates allowed (even
                                            across pasted and existing values).
                                            <br />
                                            5. Press "Enter" or "," to add a
                                            number manually.
                                            <br />
                                            6. Click "X" to remove a number.
                                            <br />
                                            7. Paste comma-separated numbers
                                            (with or without spaces) (e.g.,
                                            1234567890, 2987654321, 1122334455)
                                          </small>
                                        </div>
                                      </div>
                                      {this.state.didErrorMessage !== "" ? (
                                        <div
                                          className="example-alert example-alert-revoke mt-3 mb-3"
                                          style={{
                                            marginBottom: "15px",
                                          }}
                                        >
                                          <div className="alert alert-pro alert-danger">
                                            <div className="alert-text">
                                              <h4>DID Error</h4>
                                              <p>
                                                {this.state.didErrorMessage}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      ) : null}
                                    </div>
                                  ) : this.state.enableDids === "csv" ? (
                                    <div className="col-lg-12">
                                      {this.state.docErrorMessage !== "" ? (
                                        <div className="col-lg-12">
                                          <div
                                            className="example-alert example-alert-revoke mt-3 mb-3"
                                            style={{
                                              marginBottom: "15px",
                                            }}
                                          >
                                            <div className="alert alert-pro alert-danger">
                                              <div className="alert-text">
                                                <h4>Error</h4>
                                                <p>
                                                  {this.state.docErrorMessage}
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ) : null}
                                      <div className="card card-bordered">
                                        <div className="card-inner">
                                          <div className="col-lg-12">
                                            <div className="nk-block-head">
                                              <div className="nk-block-between-md g-4">
                                                <div className="nk-block-head-content">
                                                  <h5 className="nk-block-title title">
                                                    Upload DID File{" "}
                                                    <Tooltip
                                                      title="Upload the DID file."
                                                      placement="right"
                                                    >
                                                      <em
                                                        className="icon ni ni-info"
                                                        style={{
                                                          color: "#6576ff",
                                                        }}
                                                      ></em>
                                                    </Tooltip>
                                                  </h5>
                                                </div>
                                                <div className="nk-block-head-content">
                                                  <ul className="nk-block-tools gx-3">
                                                    <li className="order-md-last">
                                                      <a
                                                        onClick={() =>
                                                          this.downloadPdfRfq(
                                                            "dids.csv",
                                                          )
                                                        }
                                                        style={{
                                                          cursor: "pointer",
                                                          marginLeft: "15px",
                                                        }}
                                                      >
                                                        <span className="badge badge-outline-primary">
                                                          <em className="icon ni ni-download"></em>{" "}
                                                          Download Sample
                                                        </span>
                                                      </a>
                                                    </li>
                                                  </ul>
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          <div className="col-lg-12 mt-2">
                                            <div className="form-group">
                                              <div
                                                className="form-control-group"
                                                id="fileContainer"
                                              >
                                                <input
                                                  type="file"
                                                  id="add_picture"
                                                  className="file-block"
                                                  name="add_picture"
                                                  defaultValue={
                                                    this.state.add_picture
                                                  }
                                                  accept=".txt, .xls, .xlsx, .csv, .pdf, .zip"
                                                  onChange={
                                                    this.handleFileChange
                                                  }
                                                autoComplete="new-password" />
                                              </div>

                                              <p
                                                style={{
                                                  fontSize: "0.8rem",
                                                  margin: "5px 0 0 3px",
                                                }}
                                              >
                                                Upload the file of DID's.
                                                <br />
                                                Supported file formats include:
                                                .txt, .pdf, .csv, .xlsx, .xls,
                                                .zip
                                              </p>
                                              <p
                                                style={{
                                                  fontSize: "0.8rem",
                                                  margin: "2px 0 0 3px",
                                                }}
                                              >
                                                Maximum file size allowed: 50MB.
                                              </p>
                                              {this.state.add_picture_names
                                                .length > 0 && (
                                                <ul
                                                  style={{
                                                    marginLeft: "30px",
                                                  }}
                                                >
                                                  {this.state.add_picture_names.map(
                                                    (name, index) => (
                                                      <li
                                                        className="text-primary"
                                                        style={{
                                                          listStyle: "disc",
                                                        }}
                                                        key={index}
                                                      >
                                                        {name}{" "}
                                                        <a
                                                          onClick={() =>
                                                            this.handleRemoveFile(
                                                              index,
                                                            )
                                                          }
                                                          style={{
                                                            cursor: "pointer",
                                                            marginLeft: "10px",
                                                            fontSize: "16px",
                                                          }}
                                                          className="text-danger"
                                                        >
                                                          <em className="icon ni ni-trash"></em>
                                                        </a>
                                                      </li>
                                                    ),
                                                  )}
                                                </ul>
                                              )}
                                              {this.state.added_file_did &&
                                              this.state.added_file_did !==
                                                "" ? (
                                                <>
                                                  <div>
                                                    <div className="text-primary">
                                                      <Tooltip title="View / Download file">
                                                        <a
                                                          onClick={() =>
                                                            this.downloadPdf(
                                                              this.state
                                                                .added_file_did,
                                                            )
                                                          }
                                                          style={{
                                                            cursor: "pointer",
                                                            marginLeft: "10px",
                                                          }}
                                                          className="text-primary"
                                                        >
                                                          {
                                                            this.state
                                                              .added_file_did
                                                          }{" "}
                                                        </a>
                                                      </Tooltip>
                                                      <Tooltip title="View / Download file">
                                                        <a
                                                          onClick={() =>
                                                            this.downloadPdf(
                                                              this.state
                                                                .added_file_did,
                                                            )
                                                          }
                                                          style={{
                                                            cursor: "pointer",
                                                            marginLeft: "10px",
                                                            fontSize: "20px",
                                                          }}
                                                          className="text-primary"
                                                        >
                                                          {" "}
                                                          <em className="icon ni ni-download"></em>
                                                        </a>
                                                      </Tooltip>

                                                      <Tooltip title="Delete File and upload new.">
                                                        <a
                                                          onClick={() => {
                                                            this.setState({
                                                              added_file_did:
                                                                "",
                                                            });
                                                          }}
                                                          style={{
                                                            cursor: "pointer",
                                                            marginLeft: "10px",
                                                            fontSize: "20px",
                                                            color: "red",
                                                          }}
                                                          className="text-danger"
                                                        >
                                                          <em className="icon ni ni-trash"></em>
                                                        </a>
                                                      </Tooltip>
                                                    </div>
                                                  </div>
                                                </>
                                              ) : null}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                  <div className="col-lg-12">
                                    <label className="form-label" for="title">
                                      Choose Options <sup></sup>
                                    </label>
                                    <p>
                                      Please select the records sought from the
                                      options below. If the required option is
                                      not available, you may add a new one by
                                      clicking Add New Option and then the Plus
                                      button.
                                    </p>

                                    <div className="form-pm-group">
                                      <ul className="buysell-pm-list">
                                        {this.state.subpoenaOptions.map(
                                          (option, index) => (
                                            <li
                                              className="buysell-pm-item ourCheckbox"
                                              key={`options_${index}`}
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                              }}
                                            >
                                              <div>
                                                <input
                                                  type="checkbox"
                                                  //className="buysell-pm-control"
                                                  className="buysell-pm-control"
                                                  name="subscriber_settings"
                                                  onChange={() =>
                                                    this.handleCheckboxChange(
                                                      index,
                                                    )
                                                  }
                                                  id={`sub_options_${index}`}
                                                  checked={option.checked}
                                                  value="subscriber"
                                                />
                                                <label
                                                  className="buysell-pm-label"
                                                  htmlFor={`sub_options_${index}`}
                                                >
                                                  <span className="pm-name">
                                                    {option.name}
                                                  </span>
                                                </label>
                                              </div>
                                              {/*<Tooltip
                                                title="Remove Option"
                                                placement="left"
                                              >
                                                <a
                                                  style={{
                                                    cursor: "pointer",
                                                    marginRight: "20px",
                                                    fontSize: "20px",
                                                  }}
                                                  className="text-danger"
                                                  onClick={() =>
                                                    this.handleDeleteOption(
                                                      index
                                                    )
                                                  }
                                                >
                                                  <em className="icon ni ni-trash"></em>
                                                </a>
                                              </Tooltip>*/}
                                            </li>
                                          ),
                                        )}
                                      </ul>
                                    </div>
                                  </div>
                                  <div className="col-md-12">
                                    <ul className="nk-block-tools gx-3">
                                      <li className="order-md-last">
                                        <a
                                          onClick={() => {
                                            this.setState({
                                              optionsContainer: true,
                                            });
                                          }}
                                          style={{
                                            cursor: "pointer",
                                          }}
                                          className="btn btn-white btn-dim btn-outline-primary"
                                        >
                                          <span>Add New Option</span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>

                                  {this.state.optionsContainer === true ? (
                                    <div className="col-md-12">
                                      <div
                                        className="d-flex align-items-center"
                                        style={{ gap: "10px" }}
                                      >
                                        <input
                                          type="text"
                                          className="form-control"
                                          style={{
                                            height: "56px",
                                            outline: "none",
                                            boxShadow: "none",
                                            borderColor: "#c1c4cc",
                                          }}
                                          name="newName"
                                          placeholder="Enter descriptive name for your option."
                                          value={this.state.newName}
                                          onChange={this.handleInputChange}
                                        autoComplete="new-password" />
                                        <a
                                          className="btn btn-primary d-flex align-items-center justify-content-center"
                                          style={{
                                            height: "56px",
                                            width: "5%",
                                            padding: 0,
                                            color: "white",
                                            cursor: "pointer",
                                          }}
                                          onClick={this.handleAddOption}
                                        >
                                          <em
                                            className="icon ni ni-plus-sm"
                                            style={{
                                              fontSize: "20px",
                                            }}
                                          ></em>
                                        </a>
                                        <a
                                          className="btn btn-light d-flex align-items-center justify-content-center"
                                          style={{
                                            height: "56px",
                                            width: "5%",
                                            padding: 0,
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            this.setState({
                                              optionsContainer: false,
                                            });
                                          }}
                                        >
                                          Close
                                        </a>
                                      </div>
                                    </div>
                                  ) : null}

                                  <div className="col-sm-12">
                                    <div
                                      className="custom-control custom-control-lg custom-checkbox"
                                      style={{
                                        padding: 0,
                                        marginLeft: "3rem",
                                      }}
                                    >
                                      <div className="form-group mt-4">
                                        <input
                                          type="checkbox"
                                          className="custom-control-input"
                                          id="customCheckRecordsSought"
                                          onChange={() => {
                                            const isChecked =
                                              !this.state.notifyRecordsSought;
                                            this.setState({
                                              notifyRecordsSought: isChecked,
                                            });
                                            // console.log("Notify Checkbox Checked:", isChecked);
                                          }}
                                        />
                                        <label
                                          className="custom-control-label"
                                          for="customCheckRecordsSought"
                                        >
                                          Send notification to the admin
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="nk-divider divider md"></div>
                                <div className="nk-kycfm-action pt-2 text-right">
                                  {this.state.records_sought_button === true ? (
                                    <button
                                      className="btn btn-lg btn-primary"
                                      type="button"
                                      disabled
                                    >
                                      <span
                                        className="spinner-grow spinner-grow-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                      <span> Processing... </span>
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      className="btn btn-lg btn-primary"
                                      onClick={() => this.updateRecordSought()}
                                      disabled={this.state.disabled}
                                    >
                                      <em className="icon ni ni-save"></em>{" "}
                                      &nbsp; Save
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            className={
                              this.state.activeTab === "documents"
                                ? "tab-pane active"
                                : "tab-pane"
                            }
                            id="tabItemProducts4"
                          >
                            <div className="card-inner">
                              <div className="nk-block">
                                {this.state.added_file &&
                                this.state.added_file.length > 0 ? (
                                  <>
                                    <h6>Subpoena Result Documents</h6>
                                    <p>
                                      The following documents have been uploaded
                                      or created as results for each record
                                      sought in the specified subpoena request.
                                    </p>
                                  </>
                                ) : null}
                                <div className="row g-4">
                                  {this.state.errorMessageDocuments !== "" ? (
                                    <div className="col-sm-12">
                                      <div
                                        className="example-alert example-alert-revoke mt-3 mb-3"
                                        style={{ marginBottom: "15px" }}
                                      >
                                        <div className="alert alert-pro alert-danger">
                                          <div className="alert-text">
                                            <h4>
                                              {
                                                this.state
                                                  .errorMessageDocumentsTitle
                                              }
                                            </h4>
                                            <p>
                                              {this.state.errorMessageDocuments}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                  {this.state.successMessageDocuments !== "" ? (
                                    <div className="col-sm-12">
                                      <div
                                        className="example-alert example-alert-revoke mt-3 mb-3"
                                        style={{ marginBottom: "15px" }}
                                      >
                                        <div className="alert alert-pro alert-success">
                                          <div className="alert-text">
                                            <h4>Success</h4>
                                            <p>
                                              {
                                                this.state
                                                  .successMessageDocuments
                                              }
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}

                                  {this.state.added_file &&
                                  this.state.added_file.length > 0 ? (
                                    <div className="row g-4">
                                      <div className="col-sm-12 mt-2">
                                        <table className="table table-bordered">
                                          <thead>
                                            <tr>
                                              <th scope="col">Sr#</th>
                                              <th scope="col">Record Sought</th>
                                              <th scope="col">File</th>
                                              <th scope="col">Action</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {this.state.added_file.map(
                                              (item, index) => (
                                                <>
                                                  {item.added_file.map(
                                                    (file, fileIndex) => (
                                                      <tr
                                                        key={`idsx${fileIndex}`}
                                                      >
                                                        <th scope="row">
                                                          {index + 1}
                                                        </th>
                                                        <td>
                                                          {
                                                            item.choose_option_title
                                                          }
                                                        </td>
                                                        <td>{file} </td>
                                                        <td>
                                                          <Tooltip title="View / Download file">
                                                            <a
                                                              onClick={() =>
                                                                this.downloadPdf(
                                                                  file,
                                                                )
                                                              }
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                                marginLeft:
                                                                  "10px",
                                                                fontSize:
                                                                  "16px",
                                                                color:
                                                                  "#6576ff",
                                                              }}
                                                              className="text-primary"
                                                            >
                                                              <em className="icon ni ni-download"></em>
                                                            </a>
                                                          </Tooltip>
                                                          <Tooltip title="Delete File. This will delete the result document permanently.">
                                                            <a
                                                              onClick={() =>
                                                                this.deleteResultModal(
                                                                  index,
                                                                  item.id,
                                                                  item.choose_option_title,
                                                                )
                                                              }
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                                marginLeft:
                                                                  "10px",
                                                                fontSize:
                                                                  "16px",
                                                                color: "red",
                                                              }}
                                                              className="text-danger"
                                                            >
                                                              <em className="icon ni ni-trash"></em>
                                                            </a>
                                                          </Tooltip>
                                                        </td>
                                                      </tr>
                                                    ),
                                                  )}
                                                </>
                                              ),
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  ) : null}
                                  <div className="col-lg-12">
                                    <div className="nk-divider divider sm"></div>
                                  </div>

                                  <div className="col-lg-12">
                                    <div className="nk-block-head">
                                      <div className="nk-block-head-content">
                                        <h6 className="nk-block-title title">
                                          Upload New Result Document{" "}
                                        </h6>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-12">
                                    <div className="form-group">
                                      <label
                                        className="form-label"
                                        for="choose_option_title"
                                      >
                                        Choose Record Sought
                                      </label>
                                      <div className="form-control-wrap ">
                                        <div className="form-control-select">
                                          <select
                                            className="form-control form-control-lg"
                                            name="choose_option_title"
                                            id="choose_option_title"
                                            value={
                                              this.state.choose_option_title
                                            }
                                            onChange={this.handleChanges}
                                          >
                                            <option
                                              key={`opt-101`}
                                              value=""
                                            ></option>
                                            {this.state.soughtArray.map(
                                              (general, index) => (
                                                <option
                                                  key={`opt-${index}`}
                                                  value={
                                                    general.requested_option
                                                  }
                                                >
                                                  {general.requested_option}
                                                </option>
                                              ),
                                            )}
                                          </select>
                                        </div>
                                        <small>
                                          Choose an option and upload the result
                                          file associated with it
                                        </small>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-12">
                                    <div className="form-group">
                                      <div
                                        className="form-control-group"
                                        id="fileContainer"
                                      >
                                        <input
                                          type="file"
                                          id="result_document"
                                          className="file-block"
                                          name="result_document"
                                          value={this.state.result_document}
                                          accept=".png, .jpg, .jpeg, .pdf, .doc, .docx, .xls, .xlsx, .csv, .zip"
                                          onChange={this.handleFileChangeResult}
                                        autoComplete="new-password" />
                                      </div>
                                      <p
                                        style={{
                                          fontSize: "0.8rem",
                                          margin: "5px 0 0 3px",
                                        }}
                                      >
                                        Any document related to subpoena result.
                                        <br />
                                        Supported file formats include: .png,
                                        .jpg, .jpeg, .pdf, .doc, .docx, .xls,
                                        .xlsx, .csv, .zip, .docx, .doc.
                                      </p>
                                      <p
                                        style={{
                                          fontSize: "0.8rem",
                                          margin: "2px 0 0 3px",
                                        }}
                                      >
                                        Maximum file size allowed: 50MB.
                                      </p>
                                      {this.state.docErrorMessageResult !==
                                      "" ? (
                                        <div className="col-lg-12">
                                          <div
                                            className="example-alert example-alert-revoke mt-3 mb-3"
                                            style={{
                                              marginBottom: "15px",
                                            }}
                                          >
                                            <div className="alert alert-pro alert-danger">
                                              <div className="alert-text">
                                                <h4>Error</h4>
                                                <p>
                                                  {
                                                    this.state
                                                      .docErrorMessageResult
                                                  }
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ) : null}
                                      {this.state.result_documents_names
                                        .length > 0 && (
                                        <div className="row g-4">
                                          <div className="col-sm-12 mt-4">
                                            <h6>New Documents</h6>
                                            <table className="table table-bordered">
                                              <thead>
                                                <tr>
                                                  <th scope="col">Sr#</th>
                                                  <th scope="col">File</th>
                                                  <th scope="col">Action</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {this.state.result_documents_names.map(
                                                  (name, index) => (
                                                    <tr key={`idssx${index}`}>
                                                      <th scope="row">
                                                        {index + 1}
                                                      </th>
                                                      <td>{name}</td>
                                                      <td>
                                                        <Tooltip title="Delete File. Please click `Submit`.">
                                                          <a
                                                            onClick={() =>
                                                              this.handleRemoveFileResult(
                                                                index,
                                                              )
                                                            }
                                                            style={{
                                                              cursor: "pointer",
                                                              marginLeft:
                                                                "10px",
                                                              fontSize: "16px",
                                                              color: "red",
                                                            }}
                                                            className="text-danger"
                                                          >
                                                            <em className="icon ni ni-trash"></em>
                                                          </a>
                                                        </Tooltip>
                                                      </td>
                                                    </tr>
                                                  ),
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-sm-12">
                                    <div
                                      className="custom-control custom-control-lg custom-checkbox"
                                      style={{
                                        padding: 0,
                                        marginLeft: "3rem",
                                      }}
                                    >
                                      <div className="form-group mt-4">
                                        <input
                                          type="checkbox"
                                          className="custom-control-input"
                                          id="customCheckDocuments"
                                          onChange={() => {
                                            const isChecked =
                                              !this.state.notifyUpdateDocuments;
                                            this.setState({
                                              notifyUpdateDocuments: isChecked,
                                            });
                                            // console.log("Notify Checkbox Checked:", isChecked);
                                          }}
                                        />
                                        <label
                                          className="custom-control-label"
                                          for="customCheckDocuments"
                                        >
                                          Send notification to the admin
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="nk-divider divider md"></div>
                                <div className="nk-kycfm-action pt-2 text-right">
                                  {this.state.update_documents_buttons ===
                                  true ? (
                                    <button
                                      className="btn btn-lg btn-primary"
                                      type="button"
                                      disabled
                                    >
                                      <span
                                        className="spinner-grow spinner-grow-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                      <span> Processing... </span>
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      className="btn btn-lg btn-primary"
                                      onClick={() => this.updateDocuments()}
                                    >
                                      <em className="icon ni ni-save"></em>{" "}
                                      &nbsp; Save Documents
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className={
                              this.state.activeTab === "comments_emails"
                                ? "tab-pane active"
                                : "tab-pane"
                            }
                            id="tabItemProducts5"
                          >
                            <div className="card-inner">
                              <div className="nk-block">
                                <h6>Add New Comment</h6>
                                <div className="row g-4">
                                  {this.state.errorMessageComments !== "" ? (
                                    <div className="col-sm-12">
                                      <div
                                        className="example-alert example-alert-revoke mt-3 mb-3"
                                        style={{ marginBottom: "15px" }}
                                      >
                                        <div className="alert alert-pro alert-danger">
                                          <div className="alert-text">
                                            <h4>
                                              {
                                                this.state
                                                  .errorMessageCommentsTitle
                                              }
                                            </h4>
                                            <p>
                                              {this.state.errorMessageComments}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                  {this.state.successMessageComments !== "" ? (
                                    <div className="col-sm-12">
                                      <div
                                        className="example-alert example-alert-revoke mt-3 mb-3"
                                        style={{ marginBottom: "15px" }}
                                      >
                                        <div className="alert alert-pro alert-success">
                                          <div className="alert-text">
                                            <h4>Success</h4>
                                            <p>
                                              {
                                                this.state
                                                  .successMessageComments
                                              }
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                  <div
                                    className="col-lg-12"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",

                                      marginTop: "15px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        margin: 0,
                                        marginRight: "10px",
                                        color: "#344357",
                                      }}
                                      className="fs-4px"
                                    >
                                      <Tooltip
                                        title="Essential comments about the update or any other note."
                                        placement="right"
                                      >
                                        <em
                                          className="icon ni ni-info"
                                          style={{
                                            color: "#6576ff",
                                          }}
                                        ></em>
                                      </Tooltip>{" "}
                                      Comments <sup>*</sup>
                                    </span>
                                  </div>

                                  <div className="col-lg-12">
                                    <div className="form-group">
                                      <textarea
                                        className="form-control"
                                        id="comments"
                                        name="comments"
                                        maxLength="500"
                                        value={this.state.comments}
                                        onChange={this.handleChanges}
                                      ></textarea>
                                    </div>
                                  </div>
                                  <div
                                    className="custom-control custom-control-lg custom-checkbox col-lg-12"
                                    style={{
                                      padding: 0,
                                      marginLeft: "3rem",
                                    }}
                                  >
                                    <div className="form-group">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="customCheck2"
                                        onChange={() => {
                                          const isChecked =
                                            !this.state.notifyCheckBox;
                                          this.setState({
                                            notifyCheckBox: isChecked,
                                          });
                                          // console.log("Notify Checkbox Checked:", isChecked);
                                        }}
                                      />
                                      <label
                                        className="custom-control-label"
                                        for="customCheck2"
                                      >
                                        Send notifications to the admin and copy
                                        the CC email addresses
                                      </label>
                                    </div>
                                  </div>

                                  <div className="col-lg-12">
                                    <div className="form-group">
                                      <label className="form-label" for="title">
                                        CC Email(s) <sup></sup>
                                      </label>

                                      <div className="form-control-wrap">
                                        <small>
                                          These email addresses will also
                                          receive the subpoena request update if
                                          the 'Send notifications' checkbox
                                          above is selected.
                                        </small>
                                        <div style={styles.container}>
                                          <div style={styles.inputWrapper}>
                                            {this.state.emailCcs.map(
                                              (tag, index) => (
                                                <span
                                                  key={index}
                                                  style={styles.tag}
                                                >
                                                  {tag}
                                                  <button
                                                    type="button"
                                                    style={styles.removeButton}
                                                    onClick={() =>
                                                      this.handleRemoveTagCc(
                                                        index,
                                                      )
                                                    }
                                                  >
                                                    &times;
                                                  </button>
                                                </span>
                                              ),
                                            )}
                                            <input
                                              type="text"
                                              value={inputValueCc}
                                              onChange={this.handleChangeTagCc}
                                              onKeyDown={this.handleKeyDownCc}
                                              onPaste={this.handlePasteCc}
                                              placeholder="Enter or paste valid email addresses..."
                                              style={styles.input}
                                            autoComplete="new-password" />
                                          </div>
                                        </div>
                                        <small>
                                          1. Only valid email addresses are
                                          allowed.
                                          <br />
                                          2. Maximum 5 emails allowed.
                                          <br />
                                          3. No duplicates allowed (even across
                                          pasted and existing values).
                                          <br />
                                          4. Press "Enter" or "," to add an
                                          email manually.
                                          <br />
                                          6. Click "X" to remove an email.
                                          <br />
                                          7. Press "Backspace" to remove the last email.
                                          <br />
                                          8. Paste comma-separated emails (with
                                          or without spaces) (e.g.,
                                          abc@example.com,john@example.com)
                                        </small>
                                      </div>
                                    </div>
                                    {this.state.ccErrorMessage !== "" ? (
                                      <div
                                        className="example-alert example-alert-revoke mt-3 mb-3"
                                        style={{
                                          marginBottom: "15px",
                                        }}
                                      >
                                        <div className="alert alert-pro alert-danger">
                                          <div className="alert-text">
                                            <h4>CC Email Error</h4>
                                            <p>{this.state.ccErrorMessage}</p>
                                          </div>
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                                <div className="nk-divider divider md"></div>
                                <div className="nk-kycfm-action pt-2 text-right">
                                  {this.state.add_comments_button === true ? (
                                    <button
                                      className="btn btn-lg btn-primary"
                                      type="button"
                                      disabled
                                    >
                                      <span
                                        className="spinner-grow spinner-grow-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                      <span> Processing... </span>
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      className="btn btn-lg btn-primary"
                                      onClick={() => this.addComments()}
                                      disabled={this.state.disabled}
                                    >
                                      <em className="icon ni ni-save"></em>{" "}
                                      &nbsp; Submit Comment
                                    </button>
                                  )}
                                </div>
                              </div>
                              {this.state.allComments.length > 0 ? (
                                <div className="nk-block">
                                  <div className="nk-block-head nk-block-head-sm nk-block-between">
                                    <h5 className="title">Comments</h5>
                                  </div>
                                  <div className="bq-note">
                                    {visibleItems.map((item, index) => (
                                      <div
                                        className="bq-note-item"
                                        key={`comm${index}`}
                                      >
                                        <div className="bq-note-text">
                                          <p>{item.comments} </p>
                                        </div>
                                        <div className="bq-note-meta">
                                          <span className="bq-note-added">
                                            Added on{" "}
                                            <span className="date">
                                              {this.format_date_time(
                                                item.dateAdded,
                                              )}
                                            </span>{" "}
                                          </span>
                                          {item.updated_by &&
                                          item.updated_by !== "" ? (
                                            <>
                                              <span className="bq-note-sep sep">
                                                |
                                              </span>
                                              <span className="bq-note-by">
                                                By{" "}
                                                <span>{item.updated_by}</span>
                                              </span>
                                            </>
                                          ) : null}
                                          {/*<a
                                          href="#"
                                          className="link link-sm link-danger"
                                        >
                                          Delete Note
                                        </a>*/}
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                  {visibleCount < allComments.length && (
                                    <div className="d-flex justify-content-center mt-4">
                                      <button
                                        type="btton"
                                        onClick={this.handleLoadMore}
                                        className="btn btn-dim btn-outline-primary"
                                      >
                                        Load More
                                      </button>
                                    </div>
                                  )}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="card-aside card-aside-right user-aside"
                        data-content="userAside"
                        data-toggle-screen="xxl"
                        data-toggle-overlay="true"
                        data-toggle-body="true"
                      >
                        <div className="card-inner-group" data-simplebar>
                          <div className="card-inner">
                            <div className="user-card user-card-s2">
                              <div className="user-info">
                                {this.state.status === "pending" ? (
                                  <div className="badge badge-outline-primary badge-pill ucap">
                                    Pending
                                  </div>
                                ) : this.state.status === "processing" ? (
                                  <div className="badge badge-outline-info badge-pill ucap">
                                    In Process
                                  </div>
                                ) : this.state.status === "approved" ? (
                                  <div className="badge badge-outline-success badge-pill ucap">
                                    Approved
                                  </div>
                                ) : null}
                                <h5>{this.state.title}</h5>
                                <span className="sub-text">
                                  {this.state.subpoena_ren_no}
                                </span>
                              </div>
                            </div>
                          </div>
                          {this.state.status !== "approved" ? (
                            <div className="card-inner card-inner-sm">
                              <ul className="btn-toolbar justify-center gx-1">
                                <li>
                                  <Tooltip title="Approve and send this report to requester.">
                                    <a
                                      onClick={() => this.approveReportModal()}
                                      style={{
                                        cursor: "pointer",
                                        color: "#1ee0ac",
                                        fontWeight: "600",
                                      }}
                                      className="btn text-success fs-14px"
                                    >
                                      <em className="icon ni ni-done"></em>{" "}
                                      <span>Approve Request</span>
                                    </a>
                                  </Tooltip>
                                </li>
                                {this.state.show_report_link === "Yes" ? (
                                  <li>
                                    <Tooltip title="View report">
                                      <a
                                        href={`${APP_URL}viewSubpoenaReport/${this.state.report_id}`}
                                        style={{
                                          cursor: "pointer",
                                          color: "#1ee0ac",
                                          fontWeight: "600",
                                        }}
                                        className="btn text-success fs-14px"
                                        target="_blank"
                                      >
                                        <em className="icon ni ni-done"></em>{" "}
                                        <span>View Report</span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}
                              </ul>
                            </div>
                          ) : this.state.status === "approved" ? (
                            <div className="card-inner card-inner-sm">
                              <ul className="btn-toolbar justify-center gx-1">
                                <li>
                                  <Tooltip title="View the approval logs here.">
                                    <a
                                      onClick={() => this.approvalLogsModal()}
                                      style={{
                                        cursor: "pointer",
                                        color: "#6576ff",
                                        fontWeight: "600",
                                      }}
                                      className="btn text-success fs-14px"
                                    >
                                      <em className="icon ni ni-list-check"></em>{" "}
                                      <span>Approval Logs</span>
                                    </a>
                                  </Tooltip>
                                </li>
                                {this.state.show_report_link === "Yes" ? (
                                  <li>
                                    <Tooltip title="View report">
                                      <a
                                        href={`${APP_URL}viewSubpoenaReport/${this.state.report_id}`}
                                        style={{
                                          cursor: "pointer",
                                          color: "#1ee0ac",
                                          fontWeight: "600",
                                          borderLeft: "1px solid #526484",
                                          paddingLeft: "10px",
                                          marginLeft: "5px",
                                        }}
                                        className="btn text-success fs-14px"
                                        target="_blank"
                                      >
                                        <em className="icon ni ni-reports"></em>{" "}
                                        <span>View Report</span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}
                              </ul>
                            </div>
                          ) : null}

                          <div className="card-inner">
                            <h6 className="overline-title-alt mb-2">
                              <a
                                onClick={() =>
                                  this.changeActiveTab("documents")
                                }
                                style={{
                                  cursor: "pointer",
                                  fontWeight: "600",
                                }}
                                className="text-primary"
                              >
                                Progress (VIEW)
                              </a>
                            </h6>
                            <div className="row g-3">
                              <div className="col-12">
                                <div className="progress-list gy-3">
                                  <div className="progress-wrap">
                                    <div className="progress-text">
                                      <div className="progress-amount text-dark">
                                        {this.state.progressPercentage.toFixed(
                                          2,
                                        )}
                                        %
                                      </div>
                                    </div>
                                    <div className="progress progress-md">
                                      <div
                                        className="progress-bar bg-teal"
                                        data-progress={
                                          this.state.progressPercentage
                                        }
                                        style={{
                                          width: `${this.state.progressPercentage}%`,
                                        }}
                                      ></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="card-inner">
                            <div className="row text-center">
                              <div className="col-6">
                                <div className="profile-stats">
                                  <span className="amount">
                                    {this.state.added_file.length}
                                  </span>
                                  <span className="sub-text">
                                    <a
                                      onClick={() =>
                                        this.changeActiveTab("documents")
                                      }
                                      style={{
                                        cursor: "pointer",
                                        fontWeight: "600",
                                      }}
                                      className="text-primary"
                                    >
                                      Total Documents
                                    </a>
                                  </span>
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="profile-stats">
                                  <span className="amount">
                                    {this.state.allComments.length}
                                  </span>
                                  <span className="sub-text ">
                                    {" "}
                                    <a
                                      onClick={() =>
                                        this.changeActiveTab("comments_emails")
                                      }
                                      style={{
                                        cursor: "pointer",
                                        fontWeight: "600",
                                      }}
                                      className="text-primary"
                                    >
                                      Comments
                                    </a>
                                  </span>
                                </div>
                              </div>
                              {/*<div className="col-4">
                                <div className="profile-stats">
                                  <span className="amount">3</span>
                                  <span className="sub-text">Progress</span>
                                </div>
                              </div>*/}
                            </div>
                          </div>
                          <div className="card-inner">
                            <h6 className="overline-title-alt mb-2">
                              Additional Information
                            </h6>
                            <div className="row g-3">
                              <div className="col-6">
                                <span className="sub-text">Created Date:</span>
                                <span>
                                  {this.format_date(this.state.created_date)}
                                </span>
                              </div>
                              <div className="col-6">
                                <span className="sub-text">Last Updated:</span>
                                <span>
                                  {this.format_date(this.state.last_updated)}
                                </span>
                              </div>
                              <div className="col-6">
                                <span className="sub-text">Published:</span>
                                {this.state.publish_report === "Yes" ? (
                                  <span className="lead-text text-success">
                                    Yes
                                  </span>
                                ) : (
                                  <span className="lead-text text-danger">No</span>
                                )}
                              </div>
                              <div className="col-6">
                                <span className="sub-text">Published Date:</span>
                                <span>
                                  {this.format_date(this.state.published_date)}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Approval Modal MODAL START */}
          <div className="modal fade zoom" tabIndex="-1" id="modalApproval">
            <div
              className="modal-dialog modal-xl modal-dialog-top"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <div
                    className="modal-title"
                    style={{ textAlign: "center", fontSize: "20px" }}
                  >
                    <strong>
                      <em className="icon ni ni-list-round"></em> Approve
                      Request and Send Notifications
                    </strong>
                  </div>
                  <a
                    className="close"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      this.modalHideMarketingPDF("modalApproval");
                    }}
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                </div>

                <div className="modal-body">
                  {this.state.approval_main_section === true ? (
                    FormLoader()
                  ) : (
                    <div className="row g-gs">
                      {this.state.approvalErrorMessage !== "" ? (
                        <div className="col-sm-12">
                          <div className="example-alert">
                            <div className="alert alert-pro alert-danger">
                              <div className="alert-text">
                                <h4>{this.state.approvalErrorMessageTitle}</h4>

                                <p>{this.state.approvalErrorMessage}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.approvalSuccessMessage !== "" ? (
                        <div className="col-sm-12">
                          <div className="example-alert">
                            <div className="alert alert-pro alert-success">
                              <div className="alert-text">
                                <h4>Success</h4>

                                <p>{this.state.approvalSuccessMessage}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.publish_report !== "Yes" ? (
                        <div className="col-sm-12">
                          <div className="example-alert">
                            <div className="alert alert-pro alert-warning">
                              <div className="alert-text">
                                <h4>NOTE</h4>
                                <p>
                                  The request you are trying to approve has not
                                  been published yet. Click 'Approve' to approve
                                  and publish this request.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      <div className="col-sm-12">
                        <div className="nk-modal-text">
                          <div className="caption-text">
                            Do you want to approve this report? Once approved,
                            if the 'Send notifications' option is selected, it
                            will be sent to the requester and also to the CC
                            email addresses.
                          </div>
                        </div>
                        <div className="row g-4">
                          <div
                            className="col-lg-12"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginBottom: "10px",
                            }}
                          >
                            <h6
                              style={{
                                margin: 0,
                                marginRight: "10px",
                              }}
                            >
                              <Tooltip
                                title="Essential approver notes about the approval."
                                placement="right"
                              >
                                <em
                                  className="icon ni ni-info"
                                  style={{
                                    color: "#6576ff",
                                  }}
                                ></em>
                              </Tooltip>{" "}
                              Notes <sup>*</sup>
                            </h6>
                          </div>

                          <div className="col-lg-12">
                            <div className="form-group">
                              <textarea
                                className="form-control"
                                id="approval_notes"
                                name="approval_notes"
                                maxLength="500"
                                value={this.state.approval_notes}
                                onChange={this.handleChanges}
                              ></textarea>
                              <small>Maximum 500 characters are allowed.</small>
                            </div>
                          </div>
                          <div
                            className="custom-control custom-control-lg custom-checkbox col-lg-12"
                            style={{ padding: 0, marginLeft: "3rem" }}
                          >
                            <div className="form-group">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id="customCheckApproval"
                                onChange={() => {
                                  const isChecked = !this.state.notifyApproval;
                                  this.setState({
                                    notifyApproval: isChecked,
                                  });
                                  // console.log("Notify Checkbox Checked:", isChecked);
                                }}
                              />
                              <label
                                className="custom-control-label"
                                for="customCheckApproval"
                              >
                                Send notifications to the requester and copy the
                                CC email addresses
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-12">
                            <div className="form-group mt-2">
                              <label className="form-label" for="emailto">
                                Requester Email <sup></sup>
                              </label>
                              <div className="form-control-wrap">
                                <input
                                  type="text"
                                  className="form-control form-control-lg"
                                  id="approval_requester_email"
                                  name="approval_requester_email"
                                  value={this.state.approval_requester_email}
                                  onChange={this.handleChange}
                                  placeholder="Enter email address"
                                autoComplete="new-password" />
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="form-group">
                              <label className="form-label" for="title">
                                CC Email(s) <sup></sup>
                              </label>

                              <div className="form-control-wrap">
                                <small>
                                  These email addresses will also receive the
                                  subpoena details if the 'Send notifications'
                                  checkbox above is selected.
                                </small>
                                <div style={styles.container}>
                                  <div style={styles.inputWrapper}>
                                    {this.state.emailCcsApproval.map(
                                      (tag, index) => (
                                        <span key={index} style={styles.tag}>
                                          {tag}
                                          <button
                                            type="button"
                                            style={styles.removeButton}
                                            onClick={() =>
                                              this.handleRemoveTagCcApproval(
                                                index,
                                              )
                                            }
                                          >
                                            &times;
                                          </button>
                                        </span>
                                      ),
                                    )}
                                    <input
                                      type="text"
                                      value={inputValueCcApproval}
                                      onChange={this.handleChangeTagCcApproval}
                                      onKeyDown={this.handleKeyDownCcApproval}
                                      onPaste={this.handlePasteCcApproval}
                                      placeholder="Enter or paste valid email addresses..."
                                      style={styles.input}
                                    autoComplete="new-password" />
                                  </div>
                                </div>
                                <small>
                                  1. Only valid email addresses are allowed.
                                  <br />
                                  2. Maximum 5 emails allowed.
                                  <br />
                                  3. No duplicates allowed (even across pasted
                                  and existing values).
                                  <br />
                                  4. Press "Enter" or "," to add an email
                                  manually.
                                  <br />
                                  6. Click "X" to remove an email.
                                  <br />
                                  7. Paste comma-separated emails (with or
                                  without spaces) (e.g.,
                                  abc@example.com,john@example.com)
                                </small>
                              </div>
                            </div>
                            {this.state.ccErrorMessageApproval !== "" ? (
                              <div
                                className="example-alert example-alert-revoke mt-3 mb-3"
                                style={{ marginBottom: "15px" }}
                              >
                                <div className="alert alert-pro alert-danger">
                                  <div className="alert-text">
                                    <h4>CC Email Error</h4>
                                    <p>{this.state.ccErrorMessageApproval}</p>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div className="nk-modal-action border-top pt-5">
                          <div className="d-flex justify-content-end">
                            {this.state.approve_client_button ? (
                              <button
                                className="btn btn-lg btn-primary"
                                type="button"
                                disabled
                              >
                                <span
                                  className="spinner-grow spinner-grow-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span> Processing... </span>
                              </button>
                            ) : (
                              <>
                                <a
                                  style={{
                                    cursor: "pointer",
                                    marginRight: "10px",
                                  }}
                                  className="btn btn-lg btn-dim btn-outline-light"
                                  onClick={() => {
                                    this.modalHideMarketingPDF("modalApproval");
                                  }}
                                >
                                  <em className="icon ni ni-cross-round"></em>{" "}
                                  <span>Cancel</span>
                                </a>
                                {"  "}
                                <a
                                  style={{ cursor: "pointer" }}
                                  className="btn btn-lg btn-mw btn-primary"
                                  onClick={() => {
                                    this.approve_subpoena_request();
                                  }}
                                  disabled={
                                    this.state.disabled ||
                                    this.state.isProcessing
                                  } // disable button when processing
                                >
                                  <em className="icon ni ni-done"></em>{" "}
                                  <span>Approve</span>
                                </a>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <br />
                </div>
              </div>
            </div>
          </div>
          {/* Approval MODAL End */}
          {/* Approval Logs MODAL START */}
          <div className="modal fade zoom" tabIndex="-1" id="modalApprovalLogs">
            <div
              className="modal-dialog modal-xl modal-dialog-top"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <div
                    className="modal-title"
                    style={{ textAlign: "center", fontSize: "20px" }}
                  >
                    <strong>
                      <em className="icon ni ni-list-round"></em> Approval Logs
                    </strong>
                  </div>
                  <a
                    className="close"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      this.modalHideMarketingPDF("modalApprovalLogs");
                    }}
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                </div>

                <div className="modal-body">
                  {this.state.approval_logs_main_section === true ? (
                    FormLoader()
                  ) : (
                    <div className="row g-gs">
                      {this.state.approvalLogErrorMessage !== "" ? (
                        <div className="col-sm-12">
                          <div className="example-alert">
                            <div className="alert alert-pro alert-danger">
                              <div className="alert-text">
                                <h4>
                                  {this.state.approvalLogErrorMessageTitle}
                                </h4>

                                <p>{this.state.approvalLogErrorMessage}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      <div className="col-sm-12">
                        <div className="tab-pane" id="tabItem6">
                          {this.state.approvalLogs &&
                          this.state.approvalLogs.length > 0 ? (
                            <div className="col-sm-12">
                              <table className="table table-bordered">
                                <thead>
                                  <tr>
                                    <th scope="col">---</th>
                                    <th scope="col">Aprroved Date</th>
                                    <th scope="col">Requester Email</th>

                                    <th scope="col">Notification Sent</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.approvalLogs.map(
                                    (comment, index) => (
                                      <>
                                        <tr key={`idx${index}`}>
                                          <td className="tb-col-ip text-center">
                                            <span
                                              style={{
                                                cursor: "pointer",
                                                fontSize: "20px",
                                                fontWeight: "600",
                                                color: "#6576ff",
                                              }}
                                              onClick={() =>
                                                this.handleAccordionToggle(
                                                  `accordion-item-${index}`,
                                                  index,
                                                )
                                              }
                                            >
                                              <em
                                                className={`icon ni ${
                                                  this.state.activeAccordion ===
                                                  index
                                                    ? "ni-minus"
                                                    : "ni-plus"
                                                }`}
                                              ></em>
                                            </span>
                                          </td>
                                          <th scope="row">
                                            {this.format_date(
                                              comment.approvelDate,
                                            )}
                                          </th>
                                          <td>{comment.requester_email}</td>

                                          <td>
                                            {comment.notify_enabled ===
                                            "true" ? (
                                              <span className="text-success">
                                                Yes
                                              </span>
                                            ) : (
                                              <span className="text-danger">
                                                No
                                              </span>
                                            )}
                                          </td>
                                        </tr>
                                        <tr
                                          id={`accordion-item-${index}`}
                                          className="accordion-row collapse"
                                        >
                                          <td colSpan="5">
                                            <div
                                              className="accordion-inner"
                                              style={{
                                                borderRadius: "8px",
                                                padding: "15px",
                                              }}
                                            >
                                              <h6
                                                style={{
                                                  marginBottom: "5px",
                                                  color: "#333",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                CC Emails:
                                              </h6>
                                              <div
                                                style={{
                                                  lineHeight: "1.6",
                                                  color: "#555",
                                                  marginBottom: "15px",
                                                }}
                                              >
                                                <div>
                                                  {comment.email_cc &&
                                                  comment.email_cc !== ""
                                                    ? JSON.parse(
                                                        comment.email_cc,
                                                      ).join(", ")
                                                    : "No CC Emails"}
                                                </div>
                                              </div>
                                              <h6
                                                style={{
                                                  marginBottom: "5px",
                                                  color: "#333",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                Approval Notes:
                                              </h6>
                                              <div
                                                style={{
                                                  lineHeight: "1.6",
                                                  color: "#555",
                                                }}
                                              >
                                                <div>
                                                  {comment.approval_notes}
                                                </div>
                                              </div>
                                            </div>
                                          </td>
                                        </tr>
                                      </>
                                    ),
                                  )}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            <div className="alert alert-pro alert-danger">
                              <div className="alert-text">
                                <h6>No Approval Logs</h6>
                                <p>
                                  There are no approval logs at the moment.{" "}
                                </p>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  <br />
                </div>
              </div>
            </div>
          </div>
          {/* Approval Logs MODAL End */}
          {/* SUBPOENA RESULT */}
          <div className="modal fade" tabIndex="-1" id="subpoenaResult">
            <div className="modal-dialog modal-dialog-top modal-xl" role="document">
              <div className="modal-content">
                <a
                  href="#"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-header">
                  <h5 className="modal-title">Subpoena Result</h5>
                </div>
                <div className="modal-body text-center">
                  <h3>COMING SOON</h3>
                </div>
              </div>
            </div>
          </div>
          {/* SUBPOENA RESULT */}
          {/* MODAL DELETE RESULT  */}
          <div className="modal fade" tabIndex="-1" id="modalDeleteResult">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></em>
                    <h4 className="nk-modal-title">Delete Result File!</h4>
                    {this.state.deleteErrorMessage !== "" ? (
                      <div className="col-sm-12 mb-3">
                        <div className="example-alert">
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>

                              <p>{this.state.deleteErrorMessage}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    {this.state.deleteSuccessMessage !== "" ? (
                      <div className="col-sm-12 mb-3">
                        <div className="example-alert">
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>

                              <p>{this.state.deleteSuccessMessage}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    <div className="nk-modal-text">
                      <p className="lead">
                        Are you sure you want to delete the result file?
                      </p>
                      {/*<p className="text-soft">If you need help please contact us at (855) 485-7373.</p>*/}
                    </div>
                    <div className="nk-modal-action mt-5">
                      {this.state.notifyDeletion === true ? (
                        <button
                          className="btn btn-lg btn-primary"
                          type="button"
                          disabled
                        >
                          <span
                            className="spinner-grow spinner-grow-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <span> Processing... </span>
                        </button>
                      ) : (
                        <>
                          <a
                            href="#"
                            className="btn btn-lg btn-dim btn-secondary"
                            data-dismiss="modal"
                          >
                            <em className="icon ni ni-cross-round"></em>{" "}
                            <span>Cancel</span>
                          </a>
                          <a
                            style={{ cursor: "pointer" }}
                            onClick={() => this.deleteResultDocument()}
                            className="btn btn-lg btn-mw btn-primary ml-2"
                          >
                            <em className="icon ni ni-file-remove"></em>{" "}
                            <span>Delete</span>
                          </a>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* MODAL DELETE RESULT  */}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(EditSubpoenaReport);
